import React, { useEffect, useState, useRef } from 'react';
import {
    Building, User, MapPin, Globe, Mail, Phone, MessageSquare,
    MessageCircle, StickyNote, CheckSquare, Calendar, DollarSign,
    Upload, Bell, MoreHorizontal, ChevronRight, Search,
    Info, ExternalLink, X, Send, UserCheck, Users, Clock, ArrowLeft, Mic2, BadgePercent, FileText, CheckCircle, Paperclip
} from 'lucide-react';
import { Avatar } from '@mui/material';
import API_ENDPOINTS from '../../config/apiEndpoints';
import Alert from '../Alerts/Alert';
import Swal from 'sweetalert2';
import MediaLibrary from '../../components/MediaLibrary';
import './LeadActionOperation.css';

const LeadActionOperation = ({ entity, mode, onBack, onSuccess, enableTemplatePreview = false, crmOperationPerms }) => {
    // states ported from TaskDetails
    const [currentMode, setCurrentMode] = useState(mode);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // API Tokens & URLs
    const TOKEN = API_ENDPOINTS.TOKE.UNIVERSAL_TOKEN;
    const DEFAULT_USER_ID = localStorage.getItem('userId') || '34594';
    const NEW_BASE_URL = (process.env.REACT_APP_SERVICES_AZURE_BASEURL || '').replace(/\/$/, '');
    const API_BASE = (process.env.REACT_APP_WCF_API_BASE_URL || '').replace(/\/$/, '');
    const API_BASE1 = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');
    const LOCAL_BASE_URL = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');
    const NEW_ADDED_BASE_URL = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');

    // Endpoints
    const FROM_MAIL_IDS = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.NEW_GET_FROM_MAIL_ID}`;
    const Send_mail = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.SEND_MAIL_NEW}`;
    const Template_for_main = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.NEW_GET_TEMPLATE_FOR_MAIL}`;
    const Send_voice = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.NEW_SEND_VOICE}`;
    const add_voice = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.COMMON.SEND_VOICE_NEW}`;
    const Add_Notes = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.ADD_NOTES}`;
    const Pipeline_stage = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.PIPELINE_STAGE_BASED_ON_DEALPIPELINE}`;
    const save_deal = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.SAVE_DEAL}`;
    const GetWebFormListByUserId = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.GET_WEBFORM_LIST_BYUSERID}`;
    const SENDERID = `${API_BASE1}${API_ENDPOINTS.APPOINTMENTS.GET_SENDER_IDFOR_SMS}`;
    const url1 = `${NEW_BASE_URL}${API_ENDPOINTS.APPOINTMENTS.FOLLOWUPSTATUS_LIST}`;
    const url2 = `${NEW_BASE_URL}${API_ENDPOINTS.APPOINTMENTS.GET_USER_HIRERARCHY_LIST}`;
    const Sales_Activity = `${NEW_BASE_URL}${API_ENDPOINTS.TASKS.GET_SALES_ACTIVITY_TYPE}`;
    const Get_Collabrator = `${NEW_BASE_URL}${API_ENDPOINTS.APPOINTMENTS.GET_USERLIST_PHYSICALAPP_VIEW}`;
    const Add_follow_up_DLT = `${LOCAL_BASE_URL}${API_ENDPOINTS.FOLLOWUPS.ADD_FOLLOWUP_DLT}`;
    const Get_Mail_sms_DLT_ACCOUNT = `${API_BASE1}${API_ENDPOINTS.COMMON.GET_MAIL_SMS_DLT_ACCOUNT}`;
    const Send_Sms = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.NEW_SEND_SMS}`;
    const ADD_TASK_APPOINTMENT = `${NEW_BASE_URL}${API_ENDPOINTS.TASKS.INSERT_NEW_TASK_OR_APPOINTMENT}`;
    const API_BASE3 = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');
    const NEWV3_BASE_URL = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');
    const url3 = `${API_BASE3}/${API_ENDPOINTS.APPOINTMENTS.PRODUCT_SUGGESTION_FOR_FOLLOWUP}`;
    const FOR_OWNER = `${NEW_BASE_URL}${API_ENDPOINTS.APPOINTMENTS.GET_USER_HIRERARCHY_LIST}`;
    const Is_Register_for_Whatsapp = `${NEWV3_BASE_URL}/${API_ENDPOINTS.Quotation.IS_REGISTER_FOR_WHATSAPP}`.trim();
    const Whatsapp_Template = `${NEW_BASE_URL}${API_ENDPOINTS.APPOINTMENTS.WHATSAPP_TEMPLATE}`;
    const REPLACE_JSON_STR = `${NEW_BASE_URL}/${API_ENDPOINTS.APPOINTMENTS.REPLACED_JSON_STR_WHATSAPP_SEND}`;
    const SEND_TEMPLATE = `${NEW_BASE_URL}/${API_ENDPOINTS.APPOINTMENTS.SEND_WHATSAPP_TEMPLATE}`;
    const Upload_Document = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.UPLOAD_DOCUMENT}`;
    const Get_Mail_SubjectFrom_ = `${NEW_BASE_URL}${API_ENDPOINTS.COMMON.GET_MAIL_SUBJECT_FROM_TEMPLATE}`;

    // Action-specific states
    const [followupData, setFollowupData] = useState({
        Status: '1290',
        AssignedTo: DEFAULT_USER_ID,
        Date: new Date().toISOString().split('T')[0],
        Time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
        Remarks: '',
        Products: '',
        IsReAssign: false,
        IsRemindBySms: false,
        IsRemindByEmail: false,
        SmsDate: new Date().toISOString().split('T')[0],
        SmsTime: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
        EmailDate: new Date().toISOString().split('T')[0],
        EmailTime: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })
    });

    const [sendMailData, setSendMailData] = useState({
        ChooseEmails: [],
        Account: '',
        From: '',
        ReplyTo: '',
        MailMode: 'template',
        Subject: '',
        TemplateId: '',
        Body: ''
    });

    const [sendSmsData, setSendSmsData] = useState({
        ChooseNumbers: [],
        Account: '',
        SenderId: '',
        TemplateId: '',
        Message: '',
        IsUnicode: false,
        SmsType: 'Compose'
    });

    const [sendVoiceData, setSendVoiceData] = useState({
        ChooseNumbers: [],
        DnidNo: '',
        AppFlow: '',
        Route: 'trans',
        Duration: '30'
    });

    const [addTaskData, setAddTaskData] = useState({
        Title: `NewTask_${new Date().toISOString().replace(/[-:T.Z]/g, '').slice(0, 14)}`,
        Description: '',
        Remarks: '',
        SalesActivityType: '',
        DueDate: new Date().toISOString().split('T')[0],
        DueTime: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
        Owner: DEFAULT_USER_ID,
        Collaborators: []
    });

    const [appointmentData, setAppointmentData] = useState({
        Title: `NewAppointment_${new Date().getFullYear()}${(new Date().getMonth() + 1).toString().padStart(2, '0')}${new Date().getDate().toString().padStart(2, '0')}${new Date().getHours().toString().padStart(2, '0')}${new Date().getMinutes().toString().padStart(2, '0')}${new Date().getSeconds().toString().padStart(2, '0')}`,
        ActivityType: '8',
        Description: '',
        Remarks: '',
        StartDate: new Date().toISOString().split('T')[0],
        StartTime: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
        EndDate: new Date().toISOString().split('T')[0],
        EndTime: new Date(new Date().getTime() + 60 * 60 * 1000).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
        Where: '',
        CompleteAddress: '',
        Owner: DEFAULT_USER_ID,
        Collaborators: []
    });

    const [dealData, setDealData] = useState({
        Amount: '',
        PipelineId: '',
        PipelineStage: '',
        Probability: '',
        DealOwner: DEFAULT_USER_ID,
        ClosureDate: new Date().toISOString().split('T')[0]
    });

    const [notes, setNotes] = useState('');
    const [uploadData, setUploadData] = useState({ Title: '', File: null, FileName: '' });
    const [showMediaLibrary, setShowMediaLibrary] = useState(false);

    // Template Preview States
    const [showTemplatePreview, setShowTemplatePreview] = useState(false);
    const [previewTemplate, setPreviewTemplate] = useState({ name: '', html: '', url: '' });

    // Options states
    const [followupStatusOptions, setFollowupStatusOptions] = useState([]);
    const [assignedToOptions, setAssignedToOptions] = useState([]);
    const [salesActivityOptions, setSalesActivityOptions] = useState([]);
    const [collaboratorOptions, setCollaboratorOptions] = useState([]);
    const [mailAccounts, setMailAccounts] = useState([]);
    const [fromMailOptions, setFromMailOptions] = useState([]);
    const [mailTemplates, setMailTemplates] = useState([]);
    const [smsAccounts, setSmsAccounts] = useState([]);
    const [smsSenderIds, setSmsSenderIds] = useState([]);
    const [smsTemplates, setSmsTemplates] = useState([]);
    const [dniNumbers, setDniNumbers] = useState([]);
    const [appFlows, setAppFlows] = useState([]);
    const [dealPipelines, setDealPipelines] = useState([]);
    const [dealStages, setDealStages] = useState([]);
    const [salesOwners, setSalesOwners] = useState([]);
    const [webforms, setWebforms] = useState([]);
    const [selectedWebform, setSelectedWebform] = useState('');
    const [selectedWebformName, setSelectedWebformName] = useState('');
    const [leadInfo, setLeadInfo] = useState(null);
    const [smsTab, setSmsTab] = useState('Indian SMS');
    const [showCollabDropdown, setShowCollabDropdown] = useState(false);

    // WhatsApp specific states
    const [isRegisteredForWhatsapp, setIsRegisteredForWhatsapp] = useState(null);
    const [hasCheckedWhatsapp, setHasCheckedWhatsapp] = useState(false);
    const [whatsappTemplates, setWhatsappTemplates] = useState([]);
    const [isCheckingRegistration, setIsCheckingRegistration] = useState(false);
    const [whatsappStep, setWhatsappStep] = useState('none'); // 'none', 'list', 'preview'
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [whatsappVariables, setWhatsappVariables] = useState({});
    const [whatsappSearchTerm, setWhatsappSearchTerm] = useState('');

    const MERGE_FIELDS = [
        { label: 'Name', value: '[Name]' },
        { label: 'Mobile', value: '[Mobile]' },
        { label: 'Email', value: '[Email]' },
        { label: 'Company', value: '[Company]' },
        { label: 'City', value: '[City]' },
        { label: 'Address', value: '[Address]' },
        { label: 'Website', value: '[Website]' },
        { label: 'Lead Source', value: '[LeadSource]' },
        { label: 'Current Date', value: '[Date]' }
    ];

    const collabRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (collabRef.current && !collabRef.current.contains(event.target)) {
                setShowCollabDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // Product search
    const [productSearchTerm, setProductSearchTerm] = useState('');
    const [suggestedProducts, setSuggestedProducts] = useState([]);
    const [showProductDropdown, setShowProductDropdown] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [alertConfig, setAlertConfig] = useState({ show: false, type: 'success', title: '', message: '', onConfirm: null });
    const searchTimeout = useRef(null);

    // Google Maps
    const [scriptsLoaded, setScriptsLoaded] = useState(false);
    const whereInputRef = useRef(null);
    const googleAutocompleteRef = useRef(null);

    useEffect(() => {
        setCurrentMode(mode);
    }, [mode]);

    useEffect(() => {
        const leadId = entity?.enquiryId || entity?.leadId || entity?.id || "2508095";

        // If we have pre-provided contact info (e.g. from Enquiries), we can use it directly
        const hasPreProvidedEmails = entity?.emails && entity.emails.length > 0;
        const hasPreProvidedMobiles = entity?.mobiles && entity.mobiles.length > 0;

        if (currentMode === 'followup' || currentMode === 'followup-premium') {
            fetchFollowupStatuses();
            fetchSalesOwnersForFollowup();
        } else if (currentMode === 'mail' || currentMode === 'send-mail') {
            if (hasPreProvidedEmails) {
                setSendMailData(prev => ({ ...prev, ChooseEmails: entity.emails }));
                // Still need to fetch templates and accounts
                fetchMailAccounts();
                fetchFromMailIds();
                fetchMailTemplates();
            } else {
                fetchAllMailData(leadId);
            }
        } else if (currentMode === 'sms' || currentMode === 'send-sms') {
            if (hasPreProvidedMobiles) {
                setSendSmsData(prev => ({ ...prev, ChooseNumbers: entity.mobiles }));
                setSendVoiceData(prev => ({ ...prev, ChooseNumbers: entity.mobiles }));
                // Still need to fetch accounts and templates
                fetchSmsAccounts();
                fetchSmsSenderIds();
                fetchSmsTemplates();
            } else {
                fetchAllSmsData(leadId);
            }
        } else if (currentMode === 'voice' || currentMode === 'send-voice') {
            if (hasPreProvidedMobiles) {
                setSendVoiceData(prev => ({ ...prev, ChooseNumbers: entity.mobiles.slice(0, 1) }));
                setSendSmsData(prev => ({ ...prev, ChooseNumbers: entity.mobiles }));
                fetchDniNumbers();
                fetchAppFlows();
            } else {
                fetchAllVoiceData(leadId);
            }

        } else if (currentMode === 'notes' || currentMode === 'add-notes') {
            // No fetch needed
        } else if (currentMode === 'addtask' || currentMode === 'add-task') {
            fetchSalesActivityTypes();
            fetchSalesOwnersForFollowup();
            fetchCollaborators();
        } else if (currentMode === 'addappointment' || currentMode === 'add-appointment') {
            fetchAllAppointmentData(leadId);
            initGoogleMaps();
        } else if (currentMode === 'adddeal' || currentMode === 'add-deal') {
            fetchAllDealData();
        } else if (currentMode === 'fillWebform' || currentMode === 'fill-webform') {
            fetchWebforms();
        } else if (currentMode === 'whatsapp' || currentMode === 'send-whatsapp') {
            checkAndFetchWhatsapp(leadId);
        }
    }, [currentMode, entity?.enquiryId, entity?.leadId, entity?.id, entity?.emails, entity?.mobiles]);

    // Google Maps Init
    const initGoogleMaps = () => {
        const scriptId = 'google-maps-script';
        const isGoogleMapsReady = () => window.google && window.google.maps && window.google.maps.places;

        const injectPacFix = () => {
            if (!document.querySelector('style#pac-lead-fix')) {
                const style = document.createElement('style');
                style.id = 'pac-lead-fix';
                style.innerHTML = '.pac-container { z-index: 9999999 !important; }';
                document.head.appendChild(style);
            }
        };

        if (isGoogleMapsReady()) {
            setScriptsLoaded(true);
            injectPacFix();
            return;
        }

        if (!document.getElementById(scriptId)) {
            const script = document.createElement('script');
            script.id = scriptId;
            script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAO-dLMQIXYLvJeig0dbjeEqytvPg6EMd8&libraries=places&loading=async&callback=initGoogleMapsCallback`;
            script.async = true;
            script.defer = true;
            window.initGoogleMapsCallback = () => {
                setScriptsLoaded(true);
                injectPacFix();
            };
            script.onerror = () => console.error("Google Maps script failed to load");
            document.body.appendChild(script);
        } else {
            const checkInterval = setInterval(() => {
                if (isGoogleMapsReady()) {
                    setScriptsLoaded(true);
                    injectPacFix();
                    clearInterval(checkInterval);
                }
            }, 100);
            setTimeout(() => clearInterval(checkInterval), 10000);
        }
    };

    const handleViewTemplate = () => {
        const selectedId = sendMailData.TemplateId;
        if (!selectedId) return;

        const template = mailTemplates.find(t => String(t.MailTemplateId) === String(selectedId));
        if (template) {
            setPreviewTemplate({
                name: template.MailTemplateName,
                html: template.MailTemplateContent,
                url: template.MailTemplateURL
            });
            setShowTemplatePreview(true);
        }
    };

    const handleCloseTemplate = () => {
        setShowTemplatePreview(false);
        setPreviewTemplate({ name: '', html: '', url: '' });
    };

    useEffect(() => {
        let autocompleteListener = null;

        if (scriptsLoaded && (currentMode === 'addappointment' || currentMode === 'add-appointment')) {
            const initAutocomplete = () => {
                if (!whereInputRef.current || !window.google?.maps?.places) return false;

                googleAutocompleteRef.current = new window.google.maps.places.Autocomplete(whereInputRef.current, {
                    types: ['geocode', 'establishment'],
                });

                autocompleteListener = googleAutocompleteRef.current.addListener('place_changed', () => {
                    const place = googleAutocompleteRef.current.getPlace();
                    const address = place.formatted_address || place.name;
                    setAppointmentData(prev => ({
                        ...prev,
                        Where: address,
                        Latitude: place.geometry?.location?.lat() || '',
                        Longitude: place.geometry?.location?.lng() || ''
                    }));
                });
                return true;
            };

            // Try immediately
            if (!initAutocomplete()) {
                // If ref not ready, poll for a bit
                const pollInterval = setInterval(() => {
                    if (initAutocomplete()) clearInterval(pollInterval);
                }, 100);
                setTimeout(() => clearInterval(pollInterval), 5000);
            }
        }

        return () => {
            if (autocompleteListener && window.google?.maps?.event) {
                window.google.maps.event.removeListener(autocompleteListener);
            }
        };
    }, [scriptsLoaded, currentMode]);

    // Success Helper
    const showOperationSuccess = (message) => {
        showAlert('success', 'Success', message, () => {
            if (onSuccess) onSuccess();
        });
    };

    const showAlert = (type, title, message, onConfirm = null) => {
        setAlertConfig({
            show: true,
            type,
            title,
            message,
            onConfirm: () => {
                setAlertConfig(prev => ({ ...prev, show: false }));
                if (onConfirm) onConfirm();
            }
        });
    };

    // Generic Change Handler
    const handleChange = (e, setter) => {
        const { name, value, type, checked } = e.target;
        setter(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleCombinedDateTimeChange = (e, setter, dateField, timeField) => {
        const { value } = e.target; // value is YYYY-MM-DDTHH:mm
        if (!value) return;
        const [date, time] = value.split('T');
        setter(prev => ({
            ...prev,
            [dateField]: date,
            [timeField]: time
        }));
    };

    const getLocalISO = () => {
        const now = new Date();
        const tzOffset = now.getTimezoneOffset() * 60000;
        return (new Date(now - tzOffset)).toISOString().slice(0, 16);
    };

    const formatDateTimeDisplay = (dateStr, timeStr) => {
        if (!dateStr || !timeStr) return "";
        try {
            const d = new Date(`${dateStr}T${timeStr}`);
            if (isNaN(d.getTime())) return "";
            const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            return `${d.getDate().toString().padStart(2, '0')}-${months[d.getMonth()]}-${d.getFullYear()} ${timeStr}`;
        } catch (e) { return ""; }
    };

    // --- Ported Fetch Functions ---
    const fetchFollowupStatuses = async () => {
        try {
            const payload = {
                Token: TOKEN,
                Details: {
                    ParentId: Number(DEFAULT_USER_ID)
                }
            };
            const response = await fetch(url1, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=UTF-8" },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                const data = result.Details || result.d || result.data || result;
                if (Array.isArray(data)) {
                    setFollowupStatusOptions(data);
                    if (data.length > 0 && currentMode !== 'followup-premium') {
                        const defaultStatus = data.find(s => s.Text === 'Call-Back' || (s.Value && s.Value.startsWith('1290'))) || data[0];
                        const statusId = defaultStatus.Value ? defaultStatus.Value.split(',')[0] : (defaultStatus.Text || defaultStatus.Id || '');
                        setFollowupData(prev => ({ ...prev, Status: statusId }));
                    } else if (currentMode === 'followup-premium') {
                        setFollowupData(prev => ({ ...prev, Status: '' }));
                    }
                }
            }
        } catch (error) { console.error("Error fetching followup statuses:", error); }
    };

    const fetchSalesOwnersForFollowup = async () => {
        try {
            const response = await fetch(url2, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=UTF-8" },
                body: JSON.stringify({ Token: TOKEN, Details: { UserId: parseInt(DEFAULT_USER_ID, 10) } })
            });
            if (response.ok) {
                const result = await response.json();
                const dataRaw = result.Details?.data || result.Details || result.d || result.data || result;
                let parsed = Array.isArray(dataRaw) ? dataRaw : [];
                if (typeof dataRaw === 'string') { try { parsed = JSON.parse(dataRaw); } catch(e){} }
                if (Array.isArray(parsed)) setAssignedToOptions(parsed);
            }
        } catch (error) { console.error("Error fetching sales owners:", error); }
    };

    const fetchLeadDetails = async (leadId, isForSms = false) => {
        try {
            const response = await fetch('https://wcfkit19.azurewebsites.net//UserCRMCampaign/Service/IMSService.asmx/GetLeadById', {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=UTF-8", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify({ LeadId: leadId.toString() }),
            });
            if (response.ok) {
                const result = await response.json();
                if (result.d) {
                    setLeadInfo(result.d);
                    const numbers = [];
                    if (result.d.MobileNo) numbers.push(result.d.MobileNo);
                    if (result.d.Phones && result.d.Phones !== result.d.MobileNo) numbers.push(result.d.Phones);
                    const emails = [];
                    if (result.d.Email) emails.push(result.d.Email);
                    if (result.d.Emails && result.d.Emails !== result.d.Email) emails.push(result.d.Emails);

                    if (isForSms) {
                        setSendSmsData(prev => ({ ...prev, ChooseNumbers: numbers }));
                        setSendVoiceData(prev => ({ ...prev, ChooseNumbers: numbers }));
                    } else {
                        setSendMailData(prev => ({ ...prev, ChooseEmails: emails }));
                    }
                    return result.d;
                }
            }
        } catch (error) { console.error("Error fetching lead details:", error); }
        return null;
    };

    const fetchAllMailData = async (leadId) => {
        setIsSubmitting(true);
        try {
            await fetchMailAccounts();
            await fetchLeadDetails(leadId);
            await fetchFromMailIds();
            await fetchMailTemplates();
        } finally { setIsSubmitting(false); }
    };

    const fetchMailAccounts = async () => {
        try {
            const payload = {
                Token: TOKEN,
                LoggedUserId: DEFAULT_USER_ID,
                Details: { ParentId: parseInt(DEFAULT_USER_ID, 10), isSMS: false }
            };
            const response = await fetch(Get_Mail_sms_DLT_ACCOUNT, {
                method: "POST",
                headers: { "Content-Type": "application/json", "universal-token": TOKEN },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                let data = result.Details ?? result.data ?? result.d ?? result;
                if (data && typeof data === 'string') { try { data = JSON.parse(data); } catch (e) { data = []; } }
                const finalAccounts = Array.isArray(data) ? data : (data.data || []);
                setMailAccounts(finalAccounts);
                setMailAccounts(finalAccounts);
            }
        } catch (error) { console.error("Error fetching Mail accounts:", error); }
    };

    const fetchFromMailIds = async () => {
        try {
            const payload = { Token: TOKEN, Details: { UserId: Number(DEFAULT_USER_ID) } };
            const response = await fetch(FROM_MAIL_IDS, {
                method: "POST",
                headers: { "Content-Type": "application/json; charset=UTF-8", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify(payload),
            });
            if (response.ok) {
                const result = await response.json();
                const data = result?.Details || result?.d || result?.data || result;
                if (Array.isArray(data)) {
                    setFromMailOptions(data);
                }
            }
        } catch (error) { console.error("Error fetching from mail IDs:", error); }
    };

    const fetchMailTemplates = async () => {
        try {
            const payload = { Token: TOKEN, Details: { ParentId: Number(DEFAULT_USER_ID), isSMS: 0, isMail: 1 } };
            const response = await fetch(Template_for_main, {
                method: "POST",
                headers: { "Content-Type": "application/json; charset=UTF-8", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify(payload),
            });
            if (response.ok) {
                const result = await response.json();
                const data = result?.Details || result?.d || result?.data || result;
                let parsedData = Array.isArray(data) ? data : [];
                if (data && typeof data === 'string') { try { parsedData = JSON.parse(data); } catch (e) { } }
                if (Array.isArray(parsedData)) {
                    setMailTemplates(parsedData.map(item => ({
                        ...item,
                        MailTemplateId: item.MailTemplateId ?? item.Id,
                        MailTemplateName: item.MailTemplateName ?? item.Name,
                        MailTemplateContent: item.MailTemplateContent ?? item.Content,
                        MailTemplateSubject: item.MailTemplateSubject ?? item.Subject ?? ""
                    })));
                }
            }
        } catch (error) { console.error("Error fetching mail templates:", error); }
    };

    const fetchMailSubject = async (templateId) => {
        if (!templateId) return;
        try {
            const payload = {
                Token: TOKEN.toString(),
                Details: { TemplateId: templateId }
            };
            const response = await fetch(Get_Mail_SubjectFrom_, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=UTF-8" },
                body: JSON.stringify(payload)
            });
            const result = await response.json();
            const subject = result?.Details || result?.d || result?.data || "";
            if (subject) {
                setSendMailData(prev => ({ ...prev, Subject: subject }));
            }
        } catch (error) { console.error("Error fetching mail subject:", error); }
    };

    const fetchAllSmsData = async (leadId) => {
        setIsSubmitting(true);
        try {
            await fetchLeadDetails(leadId, true);
            await fetchSmsAccounts();
            await fetchSmsSenderIds();
            await fetchSmsTemplates();
        } finally { setIsSubmitting(false); }
    };

    const fetchSmsAccounts = async () => {
        try {
            const payload = {
                Token: TOKEN,
                LoggedUserId: DEFAULT_USER_ID,
                Details: { ParentId: parseInt(DEFAULT_USER_ID, 10), isSMS: true }
            };
            const response = await fetch(Get_Mail_sms_DLT_ACCOUNT, {
                method: "POST",
                headers: { "Content-Type": "application/json", "universal-token": TOKEN },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                let data = result.Details ?? result.data ?? result.d ?? result;
                if (data && typeof data === 'string') { try { data = JSON.parse(data); } catch (e) { data = []; } }
                const finalAccounts = Array.isArray(data) ? data : (data.data || []);
                setSmsAccounts(finalAccounts);
                if (finalAccounts.length > 0) setSendSmsData(prev => ({ ...prev, Account: finalAccounts[0].AccountId || finalAccounts[0].Code }));
            }
        } catch (error) { console.error("Error fetching SMS accounts:", error); }
    };

    const fetchSmsSenderIds = async () => {
        try {
            const payload = { Token: TOKEN, Details: { UserId: parseInt(DEFAULT_USER_ID, 10) } };
            const response = await fetch(SENDERID, {
                method: 'POST',
                headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                const data = result?.Details || result?.d || result?.data || result;
                let parsed = Array.isArray(data) ? data : [];
                if (data && typeof data === 'string') { try { parsed = JSON.parse(data); } catch (e) { } }
                if (Array.isArray(parsed)) {
                    setSmsSenderIds(parsed);
                    if (parsed.length > 0) setSendSmsData(prev => ({ ...prev, SenderId: parsed[0].SenderName }));
                }
            }
        } catch (error) { console.error("Error fetching sender IDs:", error); }
    };

    const fetchSmsTemplates = async () => {
        try {
            const payload = { Token: TOKEN, Details: { ParentId: Number(DEFAULT_USER_ID), isSMS: 1, isMail: 0 } };
            const response = await fetch(Template_for_main, {
                method: 'POST',
                headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                const data = result?.Details || result?.d || result?.data || result;
                let parsed = Array.isArray(data) ? data : [];
                if (data && typeof data === 'string') { try { parsed = JSON.parse(data); } catch (e) { } }
                if (Array.isArray(parsed)) setSmsTemplates(parsed);
            }
        } catch (error) { console.error("Error fetching SMS templates:", error); }
    };

    const fetchAllVoiceData = async (leadId) => {
        setIsSubmitting(true);
        try {
            await fetchLeadDetails(leadId, true);
            await fetchDniNumbers();
            await fetchAppFlows();
        } finally { setIsSubmitting(false); }
    };

    const fetchDniNumbers = async () => {
        try {
            const payload = { Token: TOKEN, Details: { ParentId: Number(DEFAULT_USER_ID), AppId: 2, Opt: 0 } };
            const response = await fetch(Send_voice, {
                method: 'POST',
                headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                const data = result.Details || result.d || result.data || result;
                let parsed = Array.isArray(data) ? data : [];
                if (data && typeof data === 'string') { try { parsed = JSON.parse(data); } catch (e) { } }
                if (Array.isArray(parsed)) {
                    setDniNumbers(parsed);
                    if (parsed.length > 0) setSendVoiceData(prev => ({ ...prev, DnidNo: parsed[0].Code || parsed[0].Id }));
                }
            }
        } catch (error) { console.error("Error fetching DNI numbers:", error); }
    };

    const fetchAppFlows = async () => {
        try {
            const payload = { Token: TOKEN, Details: { ParentId: Number(DEFAULT_USER_ID), AppId: 0, Opt: 2 } };
            const response = await fetch(Send_voice, {
                method: 'POST',
                headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                const data = result.Details || result.d || result.data || result;
                let parsed = Array.isArray(data) ? data : [];
                if (data && typeof data === 'string') { try { parsed = JSON.parse(data); } catch (e) { } }
                if (Array.isArray(parsed)) {
                    setAppFlows(parsed);
                    if (parsed.length > 0) setSendVoiceData(prev => ({ ...prev, AppFlow: parsed[0].Id || parsed[0].Text }));
                }
            }
        } catch (error) { console.error("Error fetching App flows:", error); }
    };

    const checkAndFetchWhatsapp = async (leadId) => {
        if (hasCheckedWhatsapp || isCheckingRegistration) return;
        setIsCheckingRegistration(true);
        try {
            const registered = await checkWhatsappRegistration(leadId);
            if (registered) {
                await fetchWhatsappTemplates();
            }
            setHasCheckedWhatsapp(true);
        } finally {
            setIsCheckingRegistration(false);
        }
    };

    const checkWhatsappRegistration = async (leadId) => {
        try {
            const payload = {
                Token: "-2295521862261168",
                Details: {
                    LeadId: parseInt(leadId, 10),
                    EntityName: "Lead"
                }
            };
            const response = await fetch(Is_Register_for_Whatsapp, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=UTF-8" },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();
                const data = typeof result.d === 'string' ? JSON.parse(result.d) : result.d;
                if (data && data.ChannelProfileId) {
                    setIsRegisteredForWhatsapp(true);
                    return true;
                }
            }
            setIsRegisteredForWhatsapp(false);
            return false;
        } catch (error) {
            console.error("Error checking WhatsApp registration:", error);
            setIsRegisteredForWhatsapp(false);
            return false;
        }
    };

    const fetchWhatsappTemplates = async () => {
        try {
            const payload = { 
                Token: "-2295521862261168", 
                Details: { UserId: parseInt(DEFAULT_USER_ID, 10), Mode: "approved" } 
            };
            const response = await fetch(Whatsapp_Template, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=UTF-8" },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();
                const data = result.Details || result.d || result.data || result;
                let parsed = Array.isArray(data) ? data : [];
                if (data && typeof data === 'string') { try { parsed = JSON.parse(data); } catch (e) { } }
                if (Array.isArray(parsed)) {
                    setWhatsappTemplates(parsed);
                }
            }
        } catch (error) {
            console.error("Error fetching WhatsApp templates:", error);
        }
    };

    const handleWhatsappTemplateSelect = (templateToUse) => {
        const template = templateToUse || selectedTemplate;
        if (!template) return;

        setSelectedTemplate(template);

        let content = template.Content || template.Message || template.MailTemplateContent || "";
        let headerText = "";
        let footerText = "";
        let buttons = template.Buttons || [];

        // Comprehensive extraction from templatejson or kit19TemplateJSON
        const jsonFields = ['templatejson', 'kit19TemplateJSON'];
        for (const field of jsonFields) {
            if (template[field]) {
                try {
                    const json = typeof template[field] === 'string' ? JSON.parse(template[field]) : template[field];
                    const components = json.components || [];

                    const bodyComp = components.find(c => c.type === 'BODY');
                    if (bodyComp && bodyComp.text && !content) content = bodyComp.text;

                    const headerComp = components.find(c => c.type === 'HEADER');
                    if (headerComp && headerComp.text) headerText = headerComp.text;

                    const footerComp = components.find(c => c.type === 'FOOTER');
                    if (footerComp && footerComp.text) footerText = footerComp.text;

                    const buttonComp = components.find(c => c.type === 'BUTTONS');
                    if (buttonComp && buttonComp.buttons && buttons.length === 0) buttons = buttonComp.buttons;
                } catch (e) { }
            }
        }

        const variables = {};
        const matches = content.match(/\{\{\d+\}\}/g);
        if (matches) {
            matches.forEach(match => {
                const num = match.replace(/\{\{|\}\}/g, '');
                variables[num] = "";
            });
        }

        // Also check header for variables {{1}}
        const headerMatches = headerText.match(/\{\{\d+\}\}/g);
        if (headerMatches) {
            headerMatches.forEach(match => {
                const num = match.replace(/\{\{|\}\}/g, '');
                variables[num] = "";
            });
        }

        setWhatsappVariables(variables);
        // Store the extracted structure for rendering
        setSelectedTemplate({
            ...template,
            extractedContent: content,
            extractedHeader: headerText,
            extractedFooter: footerText,
            extractedButtons: buttons
        });
        setWhatsappStep('preview');
    };

    const handleBackToSelection = () => {
        setWhatsappStep('list');
    };

    const handleWhatsappVariableChange = (num, value) => {
        setWhatsappVariables(prev => ({ ...prev, [num]: value }));
    };

    const handleSendWhatsapp = async () => {
        if (crmOperationPerms && !crmOperationPerms.SendWhatsapp) {
            Swal.fire('Access Denied', "You don't have permission to send Whatsapp messages.", 'warning');
            return;
        }
        if (!selectedTemplate) return;
        setIsSubmitting(true);
        try {
            const leadId = entity?.enquiryId || entity?.leadId || entity?.id || "2508095";

            // Step 1: Replace variables
            let content = selectedTemplate.Content || selectedTemplate.Message || selectedTemplate.MailTemplateContent || "";
            if (!content && selectedTemplate.templatejson) {
                try {
                    const json = JSON.parse(selectedTemplate.templatejson);
                    const body = json.components?.find(c => c.type === 'BODY');
                    if (body) content = body.text;
                } catch (e) { }
            }

            let replacedContent = content;
            Object.keys(whatsappVariables).forEach(key => {
                replacedContent = replacedContent.replace(`{{${key}}}`, whatsappVariables[key]);
            });

            const innerJson = {
                key: "dbcd909bcdc94576976cf0ce94b4ad54",
                username: localStorage.getItem('userName') || "kmukesh343",
                name: "whatsapp",
                remarks: replacedContent,
                whatsapp: {
                    to: entity?.Mobile || entity?.mobile || "917856245632",
                    type: "template",
                    category: selectedTemplate.category || "MARKETING",
                    recipient_type: "individual",
                    template: {
                        namespace: "",
                        language: {
                            policy: "deterministic",
                            code: selectedTemplate.tlanguage || "en"
                        },
                        name: selectedTemplate.templatename,
                        components: []
                    }
                }
            };

            const replacePayload = {
                Token: "-2295521862261168",
                Details: {
                    EntityId: parseInt(leadId, 10),
                    EntityName: "lead",
                    StringToReplace: JSON.stringify(innerJson)
                }
            };

            const response = await fetch(REPLACE_JSON_STR, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(replacePayload)
            });

            if (response.ok) {
                // Step 2: Instant Dispatch with SEND_TEMPLATE (URLSearchParams)
                const params = new URLSearchParams();
                params.append('key', innerJson.key);
                params.append('username', innerJson.username);
                params.append('name', innerJson.name);
                params.append('remarks', innerJson.remarks);

                // Flattened whatsapp object for urlencoded as per requirements
                params.append('whatsapp[to]', innerJson.whatsapp.to);
                params.append('whatsapp[type]', innerJson.whatsapp.type);
                params.append('whatsapp[category]', innerJson.whatsapp.category);
                params.append('whatsapp[recipient_type]', innerJson.whatsapp.recipient_type);
                params.append('whatsapp[template][namespace]', innerJson.whatsapp.template.namespace);
                params.append('whatsapp[template][language][policy]', innerJson.whatsapp.template.language.policy);
                params.append('whatsapp[template][language][code]', innerJson.whatsapp.template.language.code);
                params.append('whatsapp[template][name]', innerJson.whatsapp.template.name);

                const sendResponse = await fetch(SEND_TEMPLATE, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: params
                });

                if (sendResponse.ok) {
                    try {
                        const result = await sendResponse.json();
                        const successMsg = result?.meta?.developer_message || "WhatsApp message sent successfully!";
                        showAlert('success', 'Success', successMsg, () => {
                            onBack && onBack();
                            onSuccess && onSuccess();
                        });
                    } catch (e) {
                        showAlert('success', 'Success', "WhatsApp message sent successfully!", () => {
                            onBack && onBack();
                            onSuccess && onSuccess();
                        });
                    }
                } else {
                    showAlert('error', 'Error', "Replacement succeeded but final dispatch failed.");
                }
            } else {
                showAlert('error', 'Error', "Failed to process message variables (REPLACE_JSON_STR).");
            }
        } catch (error) {
            console.error("Error sending WhatsApp:", error);
            showAlert('error', 'Error', "Network error occurred.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const fetchAllDealData = async () => {
        setIsSubmitting(true);
        try {
            fetchDealPipelines();
            fetchSalesOwners();
        } finally { setIsSubmitting(false); }
    };

    const fetchDealPipelines = () => {
        const dummyPipelines = [
            { id: "152", name: "solar" }, { id: "536", name: "Study" }, { id: "1", name: "Sales Pipeline" }, { id: "3", name: "B2B Sales" }, { id: "25", name: "Renewal Pipeline" }
        ];
        setDealPipelines(dummyPipelines);
        if (dummyPipelines.length > 0) {
            setDealData(prev => ({ ...prev, PipelineId: dummyPipelines[0].id }));
            fetchDealStages(dummyPipelines[0].id);
        }
    };

    const fetchDealStages = async (pipelineId) => {
        try {
            const payload = { Token: TOKEN, Details: Number(pipelineId) };
            const response = await fetch(Pipeline_stage, {
                method: 'POST',
                headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                const d_res = result.d || result.Details || result;
                let data = [];
                if (typeof d_res === 'string') { try { const parsed = JSON.parse(d_res); data = parsed.Table || parsed || []; } catch (e) { } } else { data = d_res.Table || d_res || []; }
                if (Array.isArray(data)) {
                    setDealStages(data.map(stage => ({ id: (stage.Id || stage.Code || '').toString(), name: stage.Name || stage.Text || '' })));
                }
            }
        } catch (error) { console.error("Error fetching deal stages:", error); }
    };

    const fetchSalesActivityTypes = async () => {
        try {
            const uid = localStorage.getItem('userId') || '34594';
            const response = await fetch(Sales_Activity, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=UTF-8" },
                body: JSON.stringify({ Token: TOKEN || "-2295521862261168", Details: { UserId: parseInt(uid, 10) } })
            });
            if (response.ok) {
                const result = await response.json();
                const data = result.Details || result.d || result.data || result;
                if (Array.isArray(data)) setSalesActivityOptions(data);
            }
        } catch (error) { console.error("Error fetching sales activity types:", error); }
    };

    const fetchCollaborators = async () => {
        try {
            const uid = localStorage.getItem('userId') || '34594';
            const response = await fetch(Get_Collabrator, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=UTF-8" },
                body: JSON.stringify({ Token: "-2295521862261168", Details: { UserId: parseInt(uid, 10) } })
            });
            if (response.ok) {
                const result = await response.json();
                const rawData = result.Details?.data || result.Details || result.d || result.data || result;
                let parsed = Array.isArray(rawData) ? rawData : [];
                if (typeof rawData === 'string') { try { parsed = JSON.parse(rawData); } catch(e){} }
                setCollaboratorOptions(Array.isArray(parsed) ? parsed : []);
            }
        } catch (error) { console.error("Error fetching collaborators:", error); }
    };

    const fetchSalesOwners = async () => {
        try {
            // Using FOR_OWNER API with requested payload
            const uid = localStorage.getItem('userId') || '34594';
            const response = await fetch(FOR_OWNER, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify({ Token: TOKEN || "-2295521862261168", Details: { UserId: parseInt(uid, 10) } }),
            });
            if (response.ok) {
                const result = await response.json();
                const data = result.d || result.Details || result;
                let finalUsers = [];
                if (Array.isArray(data)) finalUsers = data; else if (typeof data === 'string') { try { finalUsers = JSON.parse(data).Table || JSON.parse(data) || []; } catch (e) { } }
                if (finalUsers.length > 0) {
                    const normalized = finalUsers.map(owner => ({
                        id: (owner.UserId || owner.User_ID || owner.ID || owner.id || owner.Code || '').toString(),
                        name: owner.Name || owner.UserName || owner.DisplayName || owner.FullName || owner.Text || 'Unknown'
                    }));
                    setSalesOwners(normalized);
                    if (normalized.length > 0 && !dealData.DealOwner) setDealData(prev => ({ ...prev, DealOwner: normalized[0].id }));
                }
            }
        } catch (error) { console.error("Error fetching sales owners:", error); }
    };

    const fetchAllAppointmentData = async (leadId) => {
        setIsSubmitting(true);
        try {
            await fetchLeadDetails(leadId, true);
            await fetchSalesActivityTypes();
            await fetchCollaborators();
            await fetchSalesOwners();
            await fetchSalesOwnersForFollowup();
        } finally { setIsSubmitting(false); }
    };

    const formatToApiDate = (dateStr) => {
        if (!dateStr) return "";
        const date = new Date(dateStr);
        const day = date.getDate().toString().padStart(2, '0');
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    };

    const handleResetFollowup = () => {
        setFollowupData({
            Status: currentMode === 'followup-premium' ? '' : '1290',
            AssignedTo: DEFAULT_USER_ID,
            Date: new Date().toISOString().split('T')[0],
            Time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
            Remarks: '',
            Products: '',
            IsReAssign: false,
            IsRemindBySms: false,
            IsRemindByEmail: false,
            SmsDate: new Date().toISOString().split('T')[0],
            SmsTime: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
            EmailDate: new Date().toISOString().split('T')[0],
            EmailTime: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })
        });
        setSelectedProducts([]);
        setProductSearchTerm('');
    };

    const handleResetMail = () => {
        setSendMailData({
            ChooseEmails: leadInfo ? [leadInfo.Email, leadInfo.Emails].filter(Boolean).filter((v, i, a) => a.indexOf(v) === i) : [],
            Account: mailAccounts.length > 0 ? (mailAccounts[0].AccountId || mailAccounts[0].Code) : '',
            From: fromMailOptions.length > 0 ? fromMailOptions[0].Value : '',
            ReplyTo: fromMailOptions.length > 0 ? fromMailOptions[0].Value : '',
            MailMode: 'template',
            Subject: '',
            TemplateId: '',
            Body: ''
        });
    };

    const handleResetSms = () => {
        setSendSmsData({
            ChooseNumbers: leadInfo ? [leadInfo.MobileNo, leadInfo.Phones].filter(Boolean).filter((v, i, a) => a.indexOf(v) === i) : [],
            Account: smsAccounts.length > 0 ? (smsAccounts[0].AccountId || smsAccounts[0].Code) : '',
            SenderId: smsSenderIds.length > 0 ? smsSenderIds[0].SenderName : '',
            TemplateId: '',
            Message: '',
            IsUnicode: false,
            SmsType: 'Compose'
        });
        setSmsTab('Indian SMS');
    };

    const handleResetVoice = () => {
        setSendVoiceData({
            ChooseNumbers: leadInfo ? [leadInfo.MobileNo, leadInfo.Phones].filter(Boolean).filter((v, i, a) => a.indexOf(v) === i) : [],
            DnidNo: dniNumbers.length > 0 ? (dniNumbers[0].Code || dniNumbers[0].Id) : '',
            AppFlow: appFlows.length > 0 ? (appFlows[0].Id || appFlows[0].Text) : '',
            Route: 'trans',
            Duration: '30'
        });
    };

    const handleResetNotes = () => {
        setNotes('');
    };

    const handleResetUpload = () => {
        setUploadData({ Title: '', File: null, FileName: '' });
    };

    const handleMediaSelect = async (media) => {
        setShowMediaLibrary(false);
        if (!media || (!media.url && !media.thumbnail)) return;
        
        const fileUrl = media.url || media.thumbnail;
        const fileName = media.name || media.FileName || "document.pdf";
        
        try {
            const response = await fetch(fileUrl);
            const blob = await response.blob();
            const file = new File([blob], fileName, { type: blob.type || "application/octet-stream" });
            setUploadData({ File: file, FileName: file.name, Title: uploadData.Title || file.name.split('.')[0] });
        } catch (err) {
            console.error("Error fetching media from library:", err);
            showAlert('error', 'Error', "Failed to load selected media from library. " + err.message);
        }
    };

    const handleResetTask = () => {
        setAddTaskData({
            Title: `NewTask_${new Date().toISOString().replace(/[-:T.Z]/g, '').slice(0, 14)}`,
            Description: '',
            Remarks: '',
            SalesActivityType: '',
            DueDate: new Date().toISOString().split('T')[0],
            DueTime: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
            Owner: DEFAULT_USER_ID,
            Collaborators: []
        });
    };

    const handleResetAppointment = () => {
        setAppointmentData({
            Title: `NewAppointment_${new Date().getFullYear()}${(new Date().getMonth() + 1).toString().padStart(2, '0')}${new Date().getDate().toString().padStart(2, '0')}${new Date().getHours().toString().padStart(2, '0')}${new Date().getMinutes().toString().padStart(2, '0')}${new Date().getSeconds().toString().padStart(2, '0')}`,
            ActivityType: '',
            Description: '',
            Remarks: '',
            StartDate: new Date().toISOString().split('T')[0],
            StartTime: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
            EndDate: new Date().toISOString().split('T')[0],
            EndTime: new Date(new Date().getTime() + 60 * 60 * 1000).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
            Where: '',
            CompleteAddress: '',
            Owner: DEFAULT_USER_ID,
            Collaborators: []
        });
    };

    const handleResetDeal = () => {
        setDealData({
            Amount: '',
            PipelineId: dealPipelines.length > 0 ? dealPipelines[0].id : '',
            PipelineStage: '',
            Probability: '',
            DealOwner: salesOwners.length > 0 ? salesOwners[0].id : DEFAULT_USER_ID,
            ClosureDate: new Date().toISOString().split('T')[0]
        });
    };

    const handleResetWebform = () => {
        setSelectedWebform('');
    };

    const fetchWebforms = async () => {
        try {
            const payload = { Token: TOKEN, Details: { UserId: Number(DEFAULT_USER_ID), FilterText: "", OffsetValue: 0, PagingSize: 100 } };
            const response = await fetch(GetWebFormListByUserId, {
                method: 'POST',
                headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                const data = result.Details || result.d || result.data || result;
                if (Array.isArray(data)) setWebforms(data); else if (typeof data === 'string') { try { setWebforms(JSON.parse(data)); } catch (e) { } }
            }
        } catch (error) { console.error("Error fetching webforms:", error); }
    };

    // --- Ported Handlers ---
    const handleProductSearch = async (e) => {
        const term = e.target.value;
        setProductSearchTerm(term);
        if (searchTimeout.current) clearTimeout(searchTimeout.current);
        if (term.length < 2) { setSuggestedProducts([]); return; }
        searchTimeout.current = setTimeout(async () => {
            try {
                const payload = { Token: TOKEN, Details: { UserId: parseInt(DEFAULT_USER_ID, 10), Term: term } };
                const response = await fetch(url3, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
                if (response.ok) {
                    const resData = await response.json();
                    if (resData.Status === "Success" || resData.Status === 1) setSuggestedProducts(resData.Details || []);
                }
            } catch (err) { console.error("Product search error:", err); }
        }, 300);
    };

    const handleProductSelect = (product) => {
        if (!selectedProducts.find(p => p.Id === product.Id)) {
            const newSelected = [...selectedProducts, product];
            setSelectedProducts(newSelected);
            setFollowupData(prev => ({ ...prev, Products: newSelected.map(p => p.Id).join(',') }));
        }
        setProductSearchTerm(''); setShowProductDropdown(false);
    };

    const handleRemoveProduct = (productId) => {
        const newSelected = selectedProducts.filter(p => p.Id !== productId);
        setSelectedProducts(newSelected);
        setFollowupData(prev => ({ ...prev, Products: newSelected.map(p => p.Id).join(',') }));
    };

    const handleSaveFollowup = async () => {
        if (crmOperationPerms && !crmOperationPerms.AddFollowup) {
            Swal.fire('Access Denied', "You don't have permission to add followups.", 'warning');
            return;
        }
        const selectedStatusObj = followupStatusOptions.find(opt => (opt.Value?.split(',')[0] || opt.Text || opt.Id) === followupData.Status);
        const statusText = selectedStatusObj?.Text || selectedStatusObj?.Name || "";

        const isMinimalStatus = (text) => {
            if (!text) return false;
            const normalized = text.toLowerCase().replace(/[^a-z0-9]/g, '');
            const negatives = [
                'notinterested', 'deadlead', 'wrongnumber', 'notreachable',
                'notresponding', 'notresponsing', 'notresonding', 'notrepsponding',
                'swoff', 'blackhole', 'paymentreceived', 'paymentrecived', 'newactivity'
            ];
            return negatives.some(n => normalized.includes(n));
        };

        if (!followupData.Status || !followupData.Remarks) {
            showAlert('error', 'Error', "Please fill all required fields");
            return;
        }

        // Validation for past date/time (Only for followup, bypass for minimal/negative statuses)
        const isMinimal = isMinimalStatus(statusText);
        if (!isMinimal) {
            const selectedDateTime = new Date(`${followupData.Date}T${followupData.Time}`);
            const now = new Date();
            if (selectedDateTime < now) {
                showAlert('error', 'Validation Error', 'Next follow-up date/time cannot be in the past');
                return;
            }
        }

        setIsSubmitting(true);
        try {
            const leadId = entity?.enquiryId || entity?.leadId || entity?.id || "2508095";
            const uid = localStorage.getItem('userId') || DEFAULT_USER_ID;

            // Helper to format date to "19 Apr 2026 11:52 PM"
            const formatForPayload = (dateVal, timeVal) => {
                if (!dateVal || !timeVal) return "";
                const d = new Date(`${dateVal}T${timeVal}`);
                const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

                let hours = d.getHours();
                const ampm = hours >= 12 ? 'PM' : 'AM';
                hours = hours % 12;
                hours = hours ? hours : 12; // hour '0' should be '12'
                const minutes = d.getMinutes().toString().padStart(2, '0');

                return `${d.getDate().toString().padStart(2, '0')} ${months[d.getMonth()]} ${d.getFullYear()} ${hours.toString().padStart(2, '0')}:${minutes} ${ampm}`;
            };

            const followupDateObj = new Date(followupData.Date);
            const formattedFollowupDate = `${(followupDateObj.getMonth() + 1).toString().padStart(2, '0')}/${followupDateObj.getDate().toString().padStart(2, '0')}/${followupDateObj.getFullYear()}`;

            if (currentMode === 'followup-premium') {
                // PREMIUM LOGIC — uses the same reliable AddLeadFollowup_DLT endpoint
                // but includes the extra notify/reminder fields for premium UX
                const formatDateForDLT = (dateStr, timeStr) => {
                    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                    try {
                        const d = new Date(`${dateStr}T${timeStr}`);
                        if (isNaN(d.getTime())) return "";
                        return `${d.getDate().toString().padStart(2, '0')}-${months[d.getMonth()]}-${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:00`;
                    } catch (e) { return ""; }
                };

                const nextStatusDate = formatDateForDLT(followupData.Date, followupData.Time);
                const smsSchedDate = followupData.IsRemindBySms ? formatDateForDLT(followupData.SmsDate, followupData.SmsTime) : nextStatusDate;
                const emailSchedDate = followupData.IsRemindByEmail ? formatDateForDLT(followupData.EmailDate, followupData.EmailTime) : nextStatusDate;

                const payload = {
                    Token: TOKEN.toString(),
                    Details: {
                        objLeadFollowup_BO: {
                            LeadId: parseInt(leadId, 10),
                            AssignedTo: parseInt(followupData.AssignedTo || uid, 10),
                            ParentID: parseInt(uid, 10),
                            CreatedBy: parseInt(uid, 10),
                            FollowUpStatus: parseInt(followupData.Status.split(',')[0], 10),
                            FupValue: followupData.Status.includes(',') ? followupData.Status : `${followupData.Status},0,0`,
                            NextStatusDate: nextStatusDate,
                            Remarks: followupData.Remarks,
                            Products: (selectedProducts || []).map(p => p.ProductName || p.Name || "").join(',') || followupData.Products || "",
                            AmountPaid: 0,
                            IsReAssign: !!followupData.IsReAssign,
                            NotifyBySMS: false,
                            NotifyByEmail: false,
                            SmsScheduelDateTime: smsSchedDate,
                            EmailScheduelDateTime: emailSchedDate
                        },
                        strDLTTemplateID: "",
                        strUserID: uid,
                        strTimeZone: "India Standard Time",
                        strParentID: uid
                    }
                };

                const endpoint = `${Add_follow_up_DLT}`;
                const response = await fetch(endpoint, {
                    method: 'POST',
                    headers: { "Content-Type": "application/json; charset=UTF-8", "X-Requested-With": "XMLHttpRequest" },
                    body: JSON.stringify(payload)
                });

                const responseText = await response.text();
                let isSuccess = false;
                if (response.ok) {
                    if (responseText.toLowerCase().includes("success") || responseText.includes('"d":null') || responseText.includes('"d":""')) isSuccess = true;
                    else {
                        try {
                            const json = JSON.parse(responseText);
                            if (json.d === null || json.d === "Success" || json.Status === 1 || json.Status === "Success") isSuccess = true;
                        } catch (e) { }
                    }
                }

                if (isSuccess) {
                    showOperationSuccess("Follow-up added successfully.");
                } else {
                    showAlert('error', 'Error', "Failed to add follow-up. " + responseText);
                }
            } else {
                // STANDARD LOGIC (Original API)
                const formatDateForStandard = (dateStr, timeStr) => {
                    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                    try {
                        const d = new Date(`${dateStr}T${timeStr}`);
                        if (isNaN(d.getTime())) return "";
                        return `${d.getDate().toString().padStart(2, '0')}-${months[d.getMonth()]}-${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:00`;
                    } catch (e) { return ""; }
                };

                const nextDate = formatDateForStandard(followupData.Date, followupData.Time);
                const payload = {
                    Token: TOKEN.toString(),
                    Details: {
                        objLeadFollowup_BO: {
                            LeadId: parseInt(leadId, 10),
                            AssignedTo: parseInt(followupData.AssignedTo || uid, 10),
                            ParentID: parseInt(uid, 10), CreatedBy: parseInt(uid, 10),
                            FollowUpStatus: parseInt(followupData.Status.split(',')[0], 10),
                            FupValue: followupData.Status.includes(',') ? followupData.Status : `${followupData.Status},0,0`,
                            NextStatusDate: nextDate, Remarks: followupData.Remarks,
                            Products: (selectedProducts || []).map(p => p.ProductName || p.Name || "").join(',') || followupData.Products || "",
                            AmountPaid: 0, IsReAssign: !!followupData.IsReAssign,
                            NotifyBySMS: false, NotifyByEmail: false,
                            SmsScheduelDateTime: nextDate, EmailScheduelDateTime: nextDate
                        },
                        strDLTTemplateID: "", strUserID: uid, strTimeZone: "India Standard Time", strParentID: uid
                    }
                };

                const endpoint = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.COMMON.ADD_FOLLOW_UP_DLT}`;
                const response = await fetch(endpoint, {
                    method: 'POST',
                    headers: { "Content-Type": "application/json; charset=UTF-8", "X-Requested-With": "XMLHttpRequest" },
                    body: JSON.stringify(payload)
                });

                const responseText = await response.text();
                let isSuccess = false;
                if (response.ok) {
                    if (responseText.toLowerCase().includes("success") || responseText.includes('"d":null') || responseText.includes('"d":""')) isSuccess = true;
                    else {
                        try {
                            const json = JSON.parse(responseText);
                            if (json.d === null || json.d === "Success" || json.Status === 1 || json.Status === "Success") isSuccess = true;
                        } catch (e) { }
                    }
                }

                if (isSuccess) { showOperationSuccess("Follow-up added successfully."); }
                else { showAlert('error', 'Error', "Failed to add follow-up. " + responseText); }
            }
        } catch (error) {
            console.error("Error adding follow-up:", error);
            showAlert('error', 'Error', "Network error occurred.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSendMail = async () => {
        if (crmOperationPerms && !crmOperationPerms.SendEmail) {
            Swal.fire('Access Denied', "You don't have permission to send emails.", 'warning');
            return;
        }
        if (sendMailData.ChooseEmails.length === 0) {
            showAlert('error', 'Error', "Please select at least one email recipient");
            return;
        }
        if (!sendMailData.Account) {
            showAlert('error', 'Error', "Please select a Mail Account");
            return;
        }
        if (!sendMailData.From) {
            showAlert('error', 'Error', "Please select a From Address");
            return;
        }
        if (!sendMailData.ReplyTo) {
            showAlert('error', 'Error', "Please select a Reply To address");
            return;
        }
        if (!sendMailData.Subject) {
            showAlert('error', 'Error', "Please enter a Subject for the email");
            return;
        }
        if (sendMailData.MailMode === 'template' && !sendMailData.TemplateId) {
            showAlert('error', 'Error', "Please select an email template");
            return;
        }
        setIsSubmitting(true);
        try {
            const leadId = entity?.enquiryId || entity?.leadId || entity?.id || "2508095";
            const payload = {
                Token: TOKEN.toString(),
                Details: {
                    objSendMail: {
                        UserId: DEFAULT_USER_ID.toString(),
                        EnquiryLeadId: leadId.toString(),
                        Account: sendMailData.Account?.toString() || "",
                        SenderName: "CRM",
                        EmailType: sendMailData.MailMode === 'template' ? "Template" : "Compose",
                        Email: sendMailData.ChooseEmails.join(','),
                        Subject: sendMailData.Subject,
                        Message: sendMailData.MailMode === 'template' ? "" : (sendMailData.Body || ""),
                        Template: sendMailData.MailMode === 'template' ? (sendMailData.TemplateId?.toString() || "0") : "0",
                        EntityType: "Lead",
                        ReplyTo: sendMailData.ReplyTo || "",
                        FromMailID: sendMailData.From || ""
                    }
                }
            };
            const response = await fetch(Send_mail, { method: 'POST', headers: { "Content-Type": "application/json; charset=UTF-8" }, body: JSON.stringify(payload) });
            if (response.ok) { showOperationSuccess("Email sent successfully."); } else { showAlert('error', 'Error', "Failed to send email"); }
        } catch (error) { console.error("Error sending mail:", error); } finally { setIsSubmitting(false); }
    };

    const handleSendSms = async () => {
        if (crmOperationPerms && !crmOperationPerms.SendSMS) {
            Swal.fire('Access Denied', "You don't have permission to send SMS.", 'warning');
            return;
        }
        if (sendSmsData.ChooseNumbers.length === 0) { showAlert('error', 'Error', "Please select at least one mobile number"); return; }
        if (!sendSmsData.Account || !sendSmsData.SenderId || !sendSmsData.Message) {
            showAlert('error', 'Error', 'Please fill all required fields marked with *');
            return;
        }
        setIsSubmitting(true);
        try {
            const payload = {
                Token: TOKEN, LoggedUserId: DEFAULT_USER_ID,
                Details: {
                    LeadId: parseInt(entity?.enquiryId || entity?.leadId || entity?.id || "13582247"),
                    AccountId: Number(DEFAULT_USER_ID), SenderId: sendSmsData.SenderId, TemplateId: sendSmsData.TemplateId.toString(),
                    Message: sendSmsData.Message, IsUnicode: !!sendSmsData.IsUnicode,
                    MobileNos: sendSmsData.ChooseNumbers.map(num => `91 ${num.replace(/\D/g, '').slice(-10)}`),
                    UserId: Number(DEFAULT_USER_ID)
                }
            };
            const response = await fetch(Send_Sms, { method: 'POST', headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
            const result = await response.json();
            if (response.ok && (result.Status === 1 || result.Status === 0 || result.Success || result.d === "Success" || result.Message === "Success")) {
                showOperationSuccess("sms send successfully");
            } else { showAlert('error', 'Error', result.Message || "Failed to send SMS"); }
        } catch (error) { console.error("Error sending SMS:", error); } finally { setIsSubmitting(false); }
    };

    const handleAddNotes = async () => {
        if (crmOperationPerms && !crmOperationPerms.AddNote) {
            Swal.fire('Access Denied', "You don't have permission to add notes.", 'warning');
            return;
        }
        if (!notes.trim()) { showAlert('error', 'Error', "Please enter some notes"); return; }
        setIsSubmitting(true);
        try {
            const payload = { Token: TOKEN, Details: { LeadId: (entity?.enquiryId || entity?.leadId || entity?.id || "2508095").toString(), Notes: notes, UserId: Number(DEFAULT_USER_ID) } };
            const response = await fetch(Add_Notes, { method: 'POST', headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
            const result = await response.json();
            if (response.ok && result.Status === 1) { showOperationSuccess("Note added successfully."); } else { showAlert('error', 'Error', result.Message || "Failed to add notes"); }
        } catch (error) { console.error("Error adding notes:", error); } finally { setIsSubmitting(false); }
    };

    const handleDocumentUpload = async () => {
        if (!uploadData.File) { showAlert('error', 'Error', "Please select a file to upload"); return; }
        setIsSubmitting(true);
        try {
            const leadIdStr = (entity?.enquiryId || entity?.leadId || entity?.id || "13582247").toString();
            const userIdInt = parseInt(localStorage.getItem('userId') || '34594', 10);

            const details = {
                Status: "",
                Message: "",
                Token: TOKEN,
                fileUpload: {
                    ParentId: userIdInt,
                    CreatedBy: userIdInt,
                    LeadId: leadIdStr
                }
            };

            const formData = new FormData();
            formData.append("details", JSON.stringify(details));
            formData.append("file", uploadData.File);

            const response = await fetch(Upload_Document, {
                method: 'POST',
                body: formData
            });

            if (response.ok) {
                const result = await response.json();
                const isSuccess = result.Status === 1 ||
                    result.status === 1 ||
                    result.Success === true ||
                    result.Success === "true" ||
                    (result.Message && result.Message.toLowerCase().includes("success"));

                if (isSuccess) {
                    showOperationSuccess("Document uploaded successfully.");
                    // Reset upload state
                    setUploadData({ Title: '', File: null, FileName: '' });
                } else {
                    showAlert('error', 'Error', result.Message || "Failed to upload document");
                }
            } else {
                const errorText = await response.text();
                showAlert('error', 'Error', errorText || "Failed to upload document due to server error");
            }
        } catch (error) {
            console.error("Error uploading document:", error);
            showAlert('error', 'Error', "Network error occurred while uploading document.");
        } finally {
            setIsSubmitting(false);
        }
    };


    const handleAddTask = async () => {
        if (crmOperationPerms && !crmOperationPerms.AddTask) {
            Swal.fire('Access Denied', "You don't have permission to add tasks.", 'warning');
            return;
        }
        if (!addTaskData.Title.trim() || !addTaskData.SalesActivityType || !addTaskData.DueDate || !addTaskData.DueTime || !addTaskData.Owner) {
            showAlert('error', 'Error', "Please fill all required fields marked with *");
            return;
        }
        setIsSubmitting(true);
        try {
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const d = new Date(`${addTaskData.DueDate}T${addTaskData.DueTime}`);
            const formattedEndDate = `${d.getDate().toString().padStart(2, '0')} ${months[d.getMonth()]} ${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;

            const leadId = entity?.enquiryId || entity?.leadId || entity?.id || "2508095";

            const uid = parseInt(localStorage.getItem('userId') || DEFAULT_USER_ID, 10);
            const payload = {
                Token: "-2295521862261168",
                Details: {
                    insertUpdateTask: {
                        Id: 0,
                        Title: addTaskData.Title,
                        Description: addTaskData.Description,
                        Remarks: addTaskData.Remarks,
                        Address: "",
                        StartDate: "",
                        AssignedTo: parseInt(addTaskData.Owner || DEFAULT_USER_ID, 10),
                        BySMS: false,
                        CollabratoerUserIds: Array.isArray(addTaskData.Collaborators) ? addTaskData.Collaborators.join('#') : (addTaskData.Collaborators || ""),
                        CompleteAddress: "",
                        CreatedBy: uid,
                        DLTTemplateIDForNotify: "",
                        DLTTemplateIDForSMSReminder: "",
                        EmailSchedul: "",
                        EmailSchedule: "",
                        EndDate: formattedEndDate,
                        IsActive: true,
                        IsAppointment: false,
                        IsEmail: false,
                        IsSMS: false,
                        IsTask: true,
                        Latitude: "",
                        LeadId: parseInt(leadId, 10),
                        Longitude: "",
                        NotifyMe: false,
                        OutcomesId: 0,
                        SmsSchedule: "",
                        Status: "open",
                        TaskId: parseInt(addTaskData.SalesActivityType, 10),
                        TaskType: ""
                    },
                    TimeZone: "India Standard Time"
                }
            };

            const response = await fetch(ADD_TASK_APPOINTMENT, { method: 'POST', headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
            const result = await response.json();

            const isSuccess = response.ok && (
                result.status === 1 ||
                result.Status === 1 ||
                result.status === "success" ||
                result.Status === "Success" ||
                result.d?.IsInserted ||
                result.d === "Success"
            );

            if (isSuccess) {
                showOperationSuccess("Task saved successfully.");
            } else {
                showAlert('error', 'Error', result.Message || "Failed to create task");
            }
        } catch (error) {
            console.error("Error adding task:", error);
            showAlert('error', 'Error', "An error occurred while saving the task.");
        } finally { setIsSubmitting(false); }
    };

    const handleSaveAppointment = async () => {
        if (crmOperationPerms && !crmOperationPerms.AddAppointment) {
            Swal.fire('Access Denied', "You don't have permission to add appointments.", 'warning');
            return;
        }
        if (!appointmentData.Title.trim() || !appointmentData.StartDate || !appointmentData.StartTime || !appointmentData.EndDate || !appointmentData.EndTime || !appointmentData.Where || !appointmentData.Owner) {
            showAlert('error', 'Error', "Please fill all required fields marked with *");
            return;
        }
        setIsSubmitting(true);
        try {
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const sd = new Date(`${appointmentData.StartDate}T${appointmentData.StartTime}`);
            const fd = new Date(`${appointmentData.EndDate}T${appointmentData.EndTime}`);

            const formattedStartDate = `${sd.getDate().toString().padStart(2, '0')} ${months[sd.getMonth()]} ${sd.getFullYear()} ${sd.getHours().toString().padStart(2, '0')}:${sd.getMinutes().toString().padStart(2, '0')}:00`;
            const formattedEndDate = `${fd.getDate().toString().padStart(2, '0')} ${months[fd.getMonth()]} ${fd.getFullYear()} ${fd.getHours().toString().padStart(2, '0')}:${fd.getMinutes().toString().padStart(2, '0')}:00`;

            const leadId = entity?.enquiryId || entity?.leadId || entity?.id || "2508095";

            const uid = parseInt(localStorage.getItem('userId') || DEFAULT_USER_ID, 10);
            const payload = {
                Token: "-2295521862261168",
                Details: {
                    insertUpdateTask: {
                        Id: 0,
                        Title: appointmentData.Title,
                        Description: appointmentData.Description,
                        Remarks: appointmentData.Remarks,
                        Address: appointmentData.Where,
                        StartDate: formattedStartDate,
                        EndDate: formattedEndDate,
                        AssignedTo: parseInt(appointmentData.Owner || DEFAULT_USER_ID, 10),
                        BySMS: false,
                        CollabratoerUserIds: Array.isArray(appointmentData.Collaborators) ? appointmentData.Collaborators.join('#') : (appointmentData.Collaborators || ""),
                        CompleteAddress: appointmentData.CompleteAddress || "",
                        CreatedBy: uid,
                        DLTTemplateIDForNotify: "",
                        DLTTemplateIDForSMSReminder: "",
                        EmailSchedul: "",
                        EmailSchedule: "",
                        IsActive: true,
                        IsAppointment: true,
                        IsEmail: false,
                        IsSMS: false,
                        IsTask: false,
                        LeadId: parseInt(leadId, 10),
                        Longitude: (appointmentData.Longitude || "").toString(),
                        Latitude: (appointmentData.Latitude || "").toString(),
                        NotifyMe: false,
                        OutcomesId: 0,
                        SmsSchedule: "",
                        Status: "open",
                        TaskId: parseInt(appointmentData.ActivityType, 10),
                        TaskType: ""
                    },
                    TimeZone: "India Standard Time"
                }
            };

            const response = await fetch(ADD_TASK_APPOINTMENT, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            const result = await response.json();
            const isSuccess = response.ok && (
                result.status === 1 ||
                result.Status === 1 ||
                result.status === "success" ||
                result.Status === "Success" ||
                result.d?.IsInserted ||
                result.d === "Success"
            );

            if (isSuccess) {
                showOperationSuccess("Appointment added successfully.");
            } else {
                showAlert('error', 'Error', "Failed to add appointment. Please try again.");
            }
        } catch (error) {
            console.error("Error saving appointment:", error);
            showAlert('error', 'Error', "An error occurred while saving the appointment.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSaveDeal = async () => {
        if (!dealData.Amount || !dealData.Probability || !dealData.PipelineStage || !dealData.ClosureDate) {
            showAlert('error', 'Error', "Please fill all required fields marked with *");
            return;
        }

        // Add validations
        if (Number(dealData.Probability) > 100) {
            showAlert('error', 'Validation Error', "Probability cannot exceed 100%");
            return;
        }

        const selectedDate = new Date(dealData.ClosureDate);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        selectedDate.setHours(0, 0, 0, 0);

        if (selectedDate < today) {
            showAlert('error', 'Validation Error', 'Estimated Closure Date cannot be in the past');
            return;
        }

        if (selectedDate.getFullYear() > 2100) {
            showAlert('error', 'Validation Error', "Please select a realistic date (before year 2100)");
            return;
        }

        setIsSubmitting(true);
        try {
            const leadId = entity?.enquiryId || entity?.leadId || entity?.id || "2508095";
            const payload = {
                Status: "",
                Message: "",
                Token: -2295521862261168,
                Details: {
                    LeadId: leadId.toString(),
                    PipelineId: Number(dealData.PipelineId),
                    PipelineStage: Number(dealData.PipelineStage),
                    Amount: Number(dealData.Amount),
                    ClosureDate: formatToApiDate(dealData.ClosureDate),
                    Probability: Number(dealData.Probability),
                    DealOwner: String(dealData.DealOwner)
                }
            };
            const response = await fetch(save_deal, { method: 'POST', headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
            if (response.ok) {
                showOperationSuccess("Deal saved successfully.");
            } else {
                showAlert('error', 'Error', "Failed to save deal");
            }
        } catch (error) {
            console.error("Error saving deal:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSendVoice = async () => {
        const selectedNum = sendVoiceData.ChooseNumbers[0];
        if (!selectedNum) { showAlert('error', 'Error', "Please select at least one mobile number"); return; }
        if (!sendVoiceData.DnidNo || !sendVoiceData.AppFlow) {
            showAlert('error', 'Error', "Please fill all required fields marked with *");
            return;
        }
        setIsSubmitting(true);
        try {
            const leadId = entity?.enquiryId || entity?.leadId || entity?.id || "";
            const payload = { Token: TOKEN, Details: { ParentId: Number(leadId) || 0, SendVoice: { MobileNo: selectedNum.replace(/\D/g, '').slice(-10), Route: sendVoiceData.Route === 'trans' ? "2" : "1", AppFlow: sendVoiceData.AppFlow || "1", DnidNo: sendVoiceData.DnidNo || "", Duration: String(sendVoiceData.Duration || "30"), EntityName: "Lead", EntityId: String(leadId) } } };
            const response = await fetch(add_voice, { method: 'POST', headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
            const result = await response.json();
            if (response.ok && result.Status === 1) { showOperationSuccess("Voice Sent Successfully"); } else { showAlert('error', 'Error', result.Message || result.Details || "Failed to initiate voice call"); }
        } catch (error) { console.error("Error sending voice:", error); } finally { setIsSubmitting(false); }
    };

    const handleSendMailChange = (e) => handleChange(e, setSendMailData);
    const handleSendSmsChange = (e) => handleChange(e, setSendSmsData);
    const handleSendVoiceChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (name === 'ChooseNumbers') {
            setSendVoiceData(prev => ({ ...prev, ChooseNumbers: checked ? [value] : [] }));
        } else {
            setSendVoiceData(prev => ({ ...prev, [name]: value }));
        }
    };
    const handleAddTaskChange = (e) => {
        const { name, value } = e.target;
        if (name === 'Remarks' && value.length > 2000) return;
        setAddTaskData(prev => ({ ...prev, [name]: value }));
    };

    const handleTaskCollabToggle = (userId) => {
        setAddTaskData(prev => {
            const current = Array.isArray(prev.Collaborators) ? prev.Collaborators : [];
            const updated = current.includes(userId)
                ? current.filter(id => id !== userId)
                : [...current, userId];
            return { ...prev, Collaborators: updated };
        });
    };
    const handleAppointmentChange = (e) => handleChange(e, setAppointmentData);
    const handleRemarksChange = (e) => {
        const { value } = e.target;
        if (value.length <= 2000) {
            setAppointmentData(prev => ({ ...prev, Remarks: value }));
        }
    };
    const handleCollabToggle = (userId) => {
        setAppointmentData(prev => {
            const current = prev.Collaborators || [];
            if (current.includes(userId)) {
                return { ...prev, Collaborators: current.filter(id => id !== userId) };
            } else {
                return { ...prev, Collaborators: [...current, userId] };
            }
        });
    };
    const handleDealChange = (e) => {
        const { name, value } = e.target;
        if (name === 'Amount' || name === 'Probability') {
            // Allow only positive integers
            const numericValue = value.replace(/[^0-9]/g, '');
            setDealData(prev => ({ ...prev, [name]: numericValue }));
        } else {
            setDealData(prev => ({ ...prev, [name]: value }));
        }
    };
    const handleNotesChange = (e) => { if (e.target.value.length <= 2000) setNotes(e.target.value); };

    const getActionTitle = () => {
        switch (currentMode) {
            case 'followup': return 'Add Followup';
            case 'followup-premium': return 'Add Followup';
            case 'mail': case 'send-mail': return 'Send Mail';
            case 'sms': case 'send-sms': return 'Send SMS';
            case 'voice': case 'send-voice': return 'Send Voice';
            case 'notes': case 'add-notes': return 'Add Notes';
            case 'upload': case 'upload-document': return 'Upload Document';
            case 'addtask': case 'add-task': return 'Add Task';
            case 'addappointment': case 'add-appointment': return 'Add Appointment';
            case 'adddeal': case 'add-deal': return 'Add Deal';
            case 'fillWebform': case 'fill-webform': return 'Fill Webform';
            case 'whatsapp': case 'send-whatsapp': return 'WhatsApp Messaging';
            default: return 'Action Operation';
        }
    };

    const getAvatarInitials = (name) => {
        if (!name) return "";
        const cleanName = name.trim();
        // Check if starts with a number or +
        if (/^[+\d]/.test(cleanName)) {
            const digits = cleanName.replace(/\D/g, '');
            return digits.substring(0, 2);
        }
        const parts = cleanName.split(/\s+/);
        if (parts.length > 1) {
            return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
        }
        return cleanName.substring(0, 2).toUpperCase();
    };

    return (
        <div className="lead-action-operation-container">
            <div className="action-operation-panel">
                {/* Conditionally show global header only for modes that DON'T have their own local card header */}
                {!['upload', 'upload-document', 'addtask', 'add-task', 'addappointment', 'add-appointment', 'adddeal', 'add-deal'].includes(currentMode) && (
                    <div className="action-operation-header">
                        <h2 className="action-title">{getActionTitle()}</h2>
                    </div>
                )}
                <div className="action-operation-content">


                    {(currentMode === 'followup' || currentMode === 'followup-premium') && (() => {
                        const selectedStatusObj = followupStatusOptions.find(opt => (opt.Value?.split(',')[0] || opt.Text || opt.Id) === followupData.Status);
                        const statusText = selectedStatusObj?.Text || selectedStatusObj?.Name || "";

                        const isMinimalStatus = (text) => {
                            if (!text) return false;
                            const normalized = text.toLowerCase().replace(/[^a-z0-9]/g, '');
                            const negatives = [
                                'notinterested', 'deadlead', 'wrongnumber', 'notreachable',
                                'notresponding', 'notresponsing', 'notresonding', 'notrepsponding',
                                'swoff', 'blackhole', 'paymentreceived', 'paymentrecived', 'newactivity'
                            ];
                            return negatives.some(n => normalized.includes(n));
                        };

                        const showMinimal = currentMode === 'followup-premium' && isMinimalStatus(statusText);
                        const showAll = currentMode === 'followup' || (currentMode === 'followup-premium' && followupData.Status && !isMinimalStatus(statusText));
                        const showInitialOnly = currentMode === 'followup-premium' && !followupData.Status;

                        return (
                            <div className="action-card">
                                <div className="action-card-body">
                                    <div className="action-form-grid">
                                        <div style={{ marginBottom: '24px' }}>
                                            {/* Primary Field */}
                                            <div className="action-form-row" style={{ marginBottom: '20px' }}>
                                                <label className="action-form-label">Choose Followup Details</label>
                                                <select name="Status" value={followupData.Status} onChange={(e) => handleChange(e, setFollowupData)} className="action-select">
                                                    {currentMode === 'followup-premium' && <option value="">---Select Follow up Status---</option>}
                                                    {followupStatusOptions.map((opt, i) => (
                                                        <option key={i} value={opt.Value?.split(',')[0] || opt.Text || opt.Id}>{opt.Text || opt.Name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        {!showMinimal && currentMode !== 'followup-premium' && (
                                            <div className="action-form-row" style={{ marginBottom: '20px' }}>
                                                <label className="action-form-label">Assign To</label>
                                                <select name="AssignedTo" value={followupData.AssignedTo} onChange={(e) => handleChange(e, setFollowupData)} className="action-select">
                                                    {assignedToOptions.map((opt, i) => (
                                                        <option key={i} value={opt.Code || opt.Id}>{opt.Text || opt.Name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        )}

                                        {/* Conditional Fields */}
                                        {showAll && (
                                            <div className="action-form-row" style={{ marginBottom: '20px' }}>
                                                <label className="action-form-label">Next Status Date</label>
                                                <div className="premium-datetime-container" onClick={(e) => e.currentTarget.querySelector('input').showPicker()}>
                                                    <Calendar size={18} className="datetime-icon" />
                                                    <div className="premium-datetime-value">
                                                        {formatDateTimeDisplay(followupData.Date, followupData.Time)}
                                                    </div>
                                                    <input
                                                        type="datetime-local"
                                                        name="DateTime"
                                                        value={`${followupData.Date}T${followupData.Time}`}
                                                        min={getLocalISO()}
                                                        onChange={(e) => handleCombinedDateTimeChange(e, setFollowupData, 'Date', 'Time')}
                                                        className="hidden-datetime-input"
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {(showAll || showMinimal || (currentMode !== 'followup-premium')) && (
                                            <div className="action-form-row" style={{ marginBottom: '20px' }}>
                                                <label className="action-form-label">Remarks</label>
                                                <textarea name="Remarks" value={followupData.Remarks} onChange={(e) => {
                                                    const val = e.target.value;
                                                    if (val.length <= 2000) handleChange(e, setFollowupData);
                                                }} className="action-textarea" placeholder="Enter remarks here..." style={{ minHeight: '100px' }}></textarea>
                                                <div style={{ textAlign: 'right', fontSize: '11px', color: '#94a3b8', marginTop: '4px' }}>
                                                    {2000 - (followupData.Remarks?.length || 0)} characters left
                                                </div>
                                            </div>
                                        )}

                                        {showAll && (
                                            <div className="action-form-row" style={{ marginBottom: '24px' }}>
                                                <label className="action-form-label">Choose Products</label>
                                                <div className="product-search-container">
                                                    <div className="selected-products-tags">
                                                        {selectedProducts.map(p => (
                                                            <span key={p.Id} className="product-tag">
                                                                {p.Name || p.ProductName}
                                                                <span className="tag-close" onClick={() => handleRemoveProduct(p.Id)}>&times;</span>
                                                            </span>
                                                        ))}
                                                    </div>
                                                    <input type="text" placeholder="Enter product name to search..." value={productSearchTerm} onChange={handleProductSearch} onFocus={() => setShowProductDropdown(true)} className="action-input" />
                                                    {showProductDropdown && suggestedProducts.length > 0 && (
                                                        <div className="product-dropdown">
                                                            {suggestedProducts.map(p => (
                                                                <div key={p.Id} className="dropdown-item" onClick={() => handleProductSelect(p)}>
                                                                    <span className="item-name">{p.Name || p.ProductName}</span>
                                                                    <span className="item-price">₹{p.Price}</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        {showAll && currentMode === 'followup-premium' && (
                                            <div className="action-form-row" style={{ marginBottom: '24px' }}>
                                                <label className="action-form-label" style={{ marginBottom: '12px' }}>Notify</label>
                                                <div className="flex flex-col gap-4">
                                                    <div className="flex flex-col gap-3">
                                                        <label className="checkbox-item" style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '14px', cursor: 'pointer', color: '#475569', fontWeight: '500' }}>
                                                            <input type="checkbox" name="IsRemindBySms" checked={followupData.IsRemindBySms} onChange={(e) => handleChange(e, setFollowupData)} style={{ width: '18px', height: '18px' }} />
                                                            By SMS
                                                        </label>
                                                        {followupData.IsRemindBySms && (
                                                            <div className="premium-datetime-container" onClick={(e) => e.currentTarget.querySelector('input').showPicker()} style={{ marginLeft: '28px', maxWidth: '320px' }}>
                                                                <Calendar size={18} className="datetime-icon" />
                                                                <div className="premium-datetime-value">
                                                                    {formatDateTimeDisplay(followupData.SmsDate, followupData.SmsTime)}
                                                                </div>
                                                                <input
                                                                    type="datetime-local"
                                                                    value={`${followupData.SmsDate}T${followupData.SmsTime}`}
                                                                    min={getLocalISO()}
                                                                    onChange={(e) => handleCombinedDateTimeChange(e, setFollowupData, 'SmsDate', 'SmsTime')}
                                                                    className="hidden-datetime-input"
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="flex flex-col gap-3">
                                                        <label className="checkbox-item" style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '14px', cursor: 'pointer', color: '#475569', fontWeight: '500' }}>
                                                            <input type="checkbox" name="IsRemindByEmail" checked={followupData.IsRemindByEmail} onChange={(e) => handleChange(e, setFollowupData)} style={{ width: '18px', height: '18px' }} />
                                                            By Mail
                                                        </label>
                                                        {followupData.IsRemindByEmail && (
                                                            <div className="premium-datetime-container" onClick={(e) => e.currentTarget.querySelector('input').showPicker()} style={{ marginLeft: '28px', maxWidth: '320px' }}>
                                                                <Calendar size={18} className="datetime-icon" />
                                                                <div className="premium-datetime-value">
                                                                    {formatDateTimeDisplay(followupData.EmailDate, followupData.EmailTime)}
                                                                </div>
                                                                <input
                                                                    type="datetime-local"
                                                                    value={`${followupData.EmailDate}T${followupData.EmailTime}`}
                                                                    min={getLocalISO()}
                                                                    onChange={(e) => handleCombinedDateTimeChange(e, setFollowupData, 'EmailDate', 'EmailTime')}
                                                                    className="hidden-datetime-input"
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {showAll && (
                                            <div className="action-form-row">
                                                <label className="action-form-label" style={{ marginBottom: '8px' }}>Follow Type</label>
                                                <label className="checkbox-item" style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '14px', cursor: 'pointer', color: '#475569', fontWeight: '500' }}>
                                                    <input type="checkbox" name="IsReAssign" checked={followupData.IsReAssign} onChange={(e) => handleChange(e, setFollowupData)} style={{ width: '18px', height: '18px', cursor: 'pointer' }} />
                                                    Re-Assign
                                                </label>
                                            </div>
                                        )}

                                    </div>
                                    <div className="action-footer" style={{ borderTop: '1px solid #f1f5f9', padding: '16px 20px', marginTop: '20px' }}>
                                         <button onClick={handleResetFollowup} style={{ background: 'none', border: 'none', color: '#64748b', fontWeight: '500', cursor: 'pointer' }}>Reset</button>
                                        <button
                                            className="btn-save"
                                            onClick={handleSaveFollowup}
                                            disabled={isSubmitting || (currentMode === 'followup-premium' && !followupData.Status)}
                                            style={{
                                                margin: 0,
                                                width: 'auto',
                                                background: (isSubmitting || (currentMode === 'followup-premium' && !followupData.Status)) ? '#22c55e' : '#22c55e',
                                                color: 'white',
                                                border: 'none',
                                                padding: '8px 24px',
                                                borderRadius: '6px',
                                                fontWeight: '600',
                                                cursor: (isSubmitting || (currentMode === 'followup-premium' && !followupData.Status)) ? 'not-allowed' : 'pointer',
                                                opacity: (isSubmitting || (currentMode === 'followup-premium' && !followupData.Status)) ? 0.6 : 1
                                            }}
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        );

                    })()}

                    {(currentMode === 'mail' || currentMode === 'send-mail') && (
                        <div className="action-card">
                            <div className="action-card-body">
                                <div className="action-form-grid">
                                    <div className="action-form-row">
                                        <label className="section-label">Choose Target Emails</label>
                                        <div className="checkbox-list">
                                            {(leadInfo || (entity?.emails && entity.emails.length > 0)) ? (() => {
                                                const emails = leadInfo 
                                                    ? [leadInfo.Email, leadInfo.Emails].filter(Boolean).filter((v, i, a) => a.indexOf(v) === i)
                                                    : (entity.emails || []);
                                                if (emails.length === 0) return <p className="no-data-found-msg" style={{ color: '#ef4444', fontSize: '13px', padding: '10px' }}>Email id not found</p>;
                                                return emails.map(email => (
                                                    <label key={email} className="checkbox-item">
                                                        <input type="checkbox" checked={sendMailData.ChooseEmails.includes(email)} onChange={(e) => {
                                                            const checked = e.target.checked;
                                                            setSendMailData(prev => ({ ...prev, ChooseEmails: checked ? [...prev.ChooseEmails, email] : prev.ChooseEmails.filter(e => e !== email) }));
                                                        }} />
                                                        {email}
                                                    </label>
                                                ));
                                            })() : <p>Loading emails...</p>}
                                        </div>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Mail Account <span style={{ color: '#ef4444' }}>*</span></label>
                                        <select name="Account" value={sendMailData.Account} onChange={handleSendMailChange} className="action-select">
                                            <option value="">--Select Account--</option>
                                            {mailAccounts.map((acc, i) => <option key={i} value={acc.AccountId || acc.Code}>{acc.AccountName || acc.Text}</option>)}
                                        </select>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">From Address <span style={{ color: '#ef4444' }}>*</span></label>
                                        <select name="From" value={sendMailData.From} onChange={handleSendMailChange} className="action-select">
                                            <option value="">--Select From Address--</option>
                                            {fromMailOptions.length > 0 ? fromMailOptions.map((opt, i) => <option key={i} value={opt.Value}>{opt.Text}</option>) : <option value="">No from address available</option>}
                                        </select>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Reply To <span style={{ color: '#ef4444' }}>*</span></label>
                                        <select name="ReplyTo" value={sendMailData.ReplyTo} onChange={handleSendMailChange} className="action-select">
                                            <option value="">--Select Reply To--</option>
                                            {fromMailOptions.length > 0 ? fromMailOptions.map((opt, i) => <option key={i} value={opt.Value}>{opt.Text}</option>) : <option value="">No reply address available</option>}
                                        </select>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Subject <span style={{ color: '#ef4444' }}>*</span></label>
                                        <input type="text" name="Subject" value={sendMailData.Subject} onChange={handleSendMailChange} className="action-input" placeholder="Email subject..." />
                                    </div>
                                    <div className="action-form-row">
                                        <div className="flex-row">
                                            <button className={`tab-btn ${sendMailData.MailMode === 'template' ? 'active' : ''}`} onClick={() => setSendMailData(prev => ({ ...prev, MailMode: 'template' }))}>Use Template</button>
                                            <button className={`tab-btn ${sendMailData.MailMode === 'compose' ? 'active' : ''}`} onClick={() => setSendMailData(prev => ({ ...prev, MailMode: 'compose' }))}>Compose</button>
                                        </div>
                                    </div>
                                    {sendMailData.MailMode === 'template' ? (
                                        <div className="action-form-row">
                                            <label className="action-form-label">Template <span style={{ color: '#ef4444' }}>*</span></label>
                                            <select name="TemplateId" value={sendMailData.TemplateId} onChange={(e) => {
                                                const tid = e.target.value;
                                                setSendMailData(prev => ({ ...prev, TemplateId: tid }));
                                                if (tid) fetchMailSubject(tid);
                                            }} className="action-select">
                                                <option value="">--Select Template--</option>
                                                {mailTemplates.map((t, i) => <option key={i} value={t.MailTemplateId}>{t.MailTemplateName}</option>)}
                                            </select>
                                            {sendMailData.TemplateId && enableTemplatePreview && (
                                                <div className="view-template-link" onClick={handleViewTemplate}>
                                                    <ExternalLink size={14} /> View Template
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="action-form-row">
                                            <label className="action-form-label">Message Body</label>
                                            <textarea name="Body" value={sendMailData.Body} onChange={handleSendMailChange} className="action-textarea" style={{ height: '150px' }}></textarea>
                                        </div>
                                    )}
                                </div>
                                <div className="action-footer">
                                    <button onClick={handleResetMail} style={{ background: 'none', border: 'none', color: '#64748b', fontWeight: '500', cursor: 'pointer' }}>Reset</button>
                                    <button className="btn-save" onClick={handleSendMail} disabled={isSubmitting}>
                                        SEND MAIL
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {(currentMode === 'sms' || currentMode === 'send-sms') && (
                        <div className="action-card">
                            <div className="action-card-body">
                                <div className="action-form-grid">
                                    <div className="action-form-row">
                                        <div className="flex-row">
                                            <button className={`tab-btn ${smsTab === 'Indian SMS' ? 'active' : ''}`} onClick={() => setSmsTab('Indian SMS')}>Indian SMS</button>
                                            <button className={`tab-btn ${smsTab === 'Non Indian SMS' ? 'active' : ''}`} onClick={() => setSmsTab('Non Indian SMS')}>Non-Indian SMS</button>
                                        </div>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="section-label">Select Phone Numbers</label>
                                        <div className="checkbox-list">
                                            {(leadInfo || (entity?.mobiles && entity.mobiles.length > 0)) ? (() => {
                                                const numbers = leadInfo 
                                                    ? [leadInfo.MobileNo, leadInfo.Phones].filter(Boolean).filter((v, i, a) => a.indexOf(v) === i)
                                                    : (entity.mobiles || []);
                                                if (numbers.length === 0) return <p className="no-data-found-msg" style={{ color: '#ef4444', fontSize: '13px', padding: '10px' }}>No Mobile no found</p>;
                                                return numbers.map(num => (
                                                    <label key={num} className="checkbox-item">
                                                        <input type="checkbox" checked={sendSmsData.ChooseNumbers.includes(num)} onChange={(e) => {
                                                            const checked = e.target.checked;
                                                            setSendSmsData(prev => ({ ...prev, ChooseNumbers: checked ? [...prev.ChooseNumbers, num] : prev.ChooseNumbers.filter(n => n !== num) }));
                                                        }} />
                                                        {num}
                                                    </label>
                                                ));
                                            })() : <p>Loading numbers...</p>}
                                        </div>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Account <span style={{ color: '#ef4444' }}>*</span></label>
                                        <select name="Account" value={sendSmsData.Account} onChange={handleSendSmsChange} className="action-select">
                                            {smsAccounts.map((acc, i) => <option key={i} value={acc.AccountId || acc.Code}>{acc.AccountName || acc.Text}</option>)}
                                        </select>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Sender ID <span style={{ color: '#ef4444' }}>*</span></label>
                                        <select name="SenderId" value={sendSmsData.SenderId} onChange={handleSendSmsChange} className="action-select">
                                            {smsSenderIds.map((s, i) => <option key={i} value={s.SenderName}>{s.SenderName}</option>)}
                                        </select>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Template</label>
                                        <select name="TemplateId" value={sendSmsData.TemplateId} onChange={(e) => {
                                            const tid = e.target.value;
                                            const template = smsTemplates.find(t => t.MailTemplateId.toString() === tid);
                                            setSendSmsData(prev => ({ ...prev, TemplateId: tid, Message: template ? template.MailTemplateContent : prev.Message }));
                                        }} className="action-select">
                                            <option value="">--Select Template--</option>
                                            {smsTemplates.map((t, i) => <option key={i} value={t.MailTemplateId}>{t.MailTemplateName}</option>)}
                                        </select>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Message <span style={{ color: '#ef4444' }}>*</span></label>
                                        <textarea name="Message" value={sendSmsData.Message} onChange={handleSendSmsChange} className="action-textarea"></textarea>
                                    </div>
                                </div>
                                <div className="action-footer">
                                    <button onClick={handleResetSms} style={{ background: 'none', border: 'none', color: '#64748b', fontWeight: '500', cursor: 'pointer' }}>Reset</button>
                                    <button className="btn-save" onClick={handleSendSms} disabled={isSubmitting}>
                                        SEND SMS
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {(currentMode === 'notes' || currentMode === 'add-notes') && (
                        <div className="action-card">
                            <div className="action-card-body">
                                <div className="action-form-grid">
                                    <div className="action-form-row">
                                        <label className="action-form-label">Notes Content <span style={{ color: '#ef4444' }}>*</span></label>
                                        <textarea value={notes} onChange={handleNotesChange} className="action-textarea" style={{ height: '250px' }} placeholder="Type your notes here..."></textarea>
                                        <span style={{ fontSize: '11px', color: '#94a3b8', textAlign: 'right' }}>{2000 - notes.length} characters remaining</span>
                                    </div>
                                </div>
                                <div className="action-footer">
                                    <button onClick={handleResetNotes} style={{ background: 'none', border: 'none', color: '#64748b', fontWeight: '500', cursor: 'pointer' }}>Reset</button>
                                    <button className="btn-save" onClick={handleAddNotes} disabled={isSubmitting || !notes.trim()}>
                                        ADD NOTE
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {(currentMode === 'upload' || currentMode === 'upload-document') && (
                        <div className="action-card">
                            <div className="action-card-header" style={{ padding: '16px 20px', borderBottom: '1px solid #f1f5f9' }}>
                                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '700', color: '#1e293b' }}>Document</h3>
                            </div>
                            <div className="action-card-body">
                                <div className="action-form-grid">
                                    <div className="action-form-row">
                                        <label className="action-form-label">Select Document</label>
                                        <div className="file-upload-container-boxed">
                                            <div className="upload-row">
                                                <button type="button" className="btn-browse-modern" onClick={() => setShowMediaLibrary(true)}>
                                                    Browse Media Library...
                                                </button>
                                                <input type="text" value={uploadData.FileName || uploadData.Title} readOnly className="action-input-minimal" placeholder="No file selected" style={{ marginLeft: '10px' }} />
                                            </div>
                                            <div className="upload-meta-row">
                                                <span className="max-size-text-green">(Max File Size 5 MB)</span>
                                                <span className="supported-formats-link-blue" onClick={() => { }}>Click here to see supported file format</span>
                                            </div>
                                            <div className="extensions-box-light">
                                                .bmp , .csv , .doc , .docx , .gif , .jpeg , .jpg , .pdf , .png , .ppt , .pptx , .txt , .xls , .xlsx
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="action-footer">
                                    <button onClick={handleResetUpload} style={{ background: 'none', border: 'none', color: '#64748b', fontWeight: '500', cursor: 'pointer' }}>Reset</button>
                                    <button className="btn-save" onClick={handleDocumentUpload} disabled={isSubmitting || !uploadData.File}>
                                        UPLOAD DOCUMENT
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {showMediaLibrary && (
                        <MediaLibrary
                            show={showMediaLibrary}
                            onclose={() => setShowMediaLibrary(false)}
                            onSelectMedia={handleMediaSelect}
                            filterOption="All"
                            cardType="image"
                            leadId={(entity?.enquiryId || entity?.leadId || entity?.id || 0)}
                        />
                    )}

                    {(currentMode === 'addtask' || currentMode === 'add-task') && (
                        <div className="action-card">
                            <div className="action-card-header" style={{ padding: '16px 20px', borderBottom: '1px solid #f1f5f9' }}>
                                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '700', color: '#1e293b' }}>Add Task</h3>
                            </div>
                            <div className="action-card-body">
                                <div className="action-form-grid">
                                    <div className="action-form-row">
                                        <label className="action-form-label">Title <span style={{ color: '#ef4444' }}>*</span></label>
                                        <input type="text" name="Title" value={addTaskData.Title} onChange={handleAddTaskChange} className="action-input" />
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Description</label>
                                        <textarea name="Description" value={addTaskData.Description} onChange={handleAddTaskChange} className="action-textarea" style={{ minHeight: '80px' }} placeholder="Start typing the details about the task..."></textarea>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Remarks</label>
                                        <textarea name="Remarks" value={addTaskData.Remarks} onChange={handleAddTaskChange} className="action-textarea" style={{ minHeight: '80px' }} placeholder="Add any additional remarks..."></textarea>
                                        <div style={{ textAlign: 'right', fontSize: '12px', color: '#64748b', marginTop: '4px' }}>
                                            {2000 - (addTaskData.Remarks?.length || 0)} characters left
                                        </div>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Sales Activity Type <span style={{ color: '#ef4444' }}>*</span></label>
                                        <select name="SalesActivityType" value={addTaskData.SalesActivityType} onChange={handleAddTaskChange} className="action-select">
                                            <option value="">--Select Activity Type--</option>
                                            {salesActivityOptions.map((opt, i) => <option key={i} value={opt.TasKId || opt.Id}>{opt.TasKName || opt.Text}</option>)}
                                        </select>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Due Date and Time <span style={{ color: '#ef4444' }}>*</span></label>
                                        <div className="premium-datetime-container" onClick={(e) => e.currentTarget.querySelector('input').showPicker()}>
                                            <Calendar size={18} className="datetime-icon" />
                                            <div className="premium-datetime-value">
                                                {formatDateTimeDisplay(addTaskData.DueDate, addTaskData.DueTime)}
                                            </div>
                                            <input
                                                type="datetime-local"
                                                value={`${addTaskData.DueDate}T${addTaskData.DueTime}`}
                                                onChange={(e) => handleCombinedDateTimeChange(e, setAddTaskData, 'DueDate', 'DueTime')}
                                                className="hidden-datetime-input"
                                            />
                                        </div>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Owner <span style={{ color: '#ef4444' }}>*</span></label>
                                        <select name="Owner" value={addTaskData.Owner} onChange={handleAddTaskChange} className="action-select">
                                            {assignedToOptions.map((opt, i) => <option key={i} value={opt.Code || opt.Id}>{opt.Text || opt.Name}</option>)}
                                        </select>
                                    </div>
                                    <div className="action-form-row" ref={collabRef} style={{ position: 'relative' }}>
                                        <label className="action-form-label">Collaborators</label>
                                        <div
                                            className="action-textarea"
                                            style={{ cursor: 'pointer', minHeight: '46px', display: 'flex', flexWrap: 'wrap', alignItems: 'center', padding: '10px 12px', gap: '6px' }}
                                            onClick={() => setShowCollabDropdown(!showCollabDropdown)}
                                        >
                                            {addTaskData.Collaborators.length > 0
                                                ? collaboratorOptions.filter(c => addTaskData.Collaborators.includes((c.Code || c.Id || '').toString())).map(c => (
                                                    <span key={c.Code || c.Id} style={{ background: '#e2e8f0', color: '#475569', padding: '2px 8px', borderRadius: '4px', fontSize: '12px', display: 'flex', alignItems: 'center', gap: '6px', border: '1px solid #cbd5e1' }}>
                                                        {c.Text || c.Name}
                                                        <X size={12} style={{ cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); handleTaskCollabToggle((c.Code || c.Id || '').toString()); }} />
                                                    </span>
                                                ))
                                                : <span style={{ color: '#94a3b8' }}>--Select Collaborator--</span>}
                                            <div style={{ flex: 1 }}></div>
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ transition: 'transform 0.2s ease', transform: showCollabDropdown ? 'rotate(180deg)' : 'rotate(0deg)', flexShrink: 0 }}><polyline points="6 9 12 15 18 9" /></svg>
                                        </div>
                                        {showCollabDropdown && (
                                            <div className="checkbox-list" style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 100, background: 'white', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', marginTop: '4px', maxHeight: '200px', overflowY: 'auto' }}>
                                                {collaboratorOptions.map((c, i) => {
                                                    const id = (c.Code || c.Id || '').toString();
                                                    return (
                                                        <label key={i} className="checkbox-item" style={{ padding: '8px 12px' }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={addTaskData.Collaborators.includes(id)}
                                                                onChange={() => handleTaskCollabToggle(id)}
                                                            />
                                                            {c.Text || c.Name}
                                                        </label>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="action-footer">
                                    <button onClick={handleResetTask} style={{ background: 'none', border: 'none', color: '#64748b', fontWeight: '500', cursor: 'pointer' }}>Reset</button>
                                    <button className="btn-save" onClick={handleAddTask} disabled={isSubmitting}>
                                        SAVE
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {(currentMode === 'addappointment' || currentMode === 'add-appointment') && (
                        <div className="action-card">
                            <div className="action-card-header" style={{ padding: '16px 20px', borderBottom: '1px solid #f1f5f9' }}>
                                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '700', color: '#1e293b' }}>Add Appointment</h3>
                            </div>
                            <div className="action-card-body">
                                <div className="action-form-grid">
                                    <div className="action-form-row">
                                        <label className="action-form-label">Title <span style={{ color: '#ef4444' }}>*</span></label>
                                        <input type="text" name="Title" value={appointmentData.Title} onChange={handleAppointmentChange} className="action-input" />
                                    </div>
                                    <div className="action-form-row" style={{ display: 'none' }}>
                                        <label className="action-form-label">Sales Activity Type</label>
                                        <select name="ActivityType" value={appointmentData.ActivityType} onChange={handleAppointmentChange} className="action-select">
                                            <option value="">--Select Activity Type--</option>
                                            {salesActivityOptions.map((opt, i) => <option key={i} value={opt.TasKId || opt.Id}>{opt.TasKName || opt.Text}</option>)}
                                        </select>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Description</label>
                                        <textarea name="Description" value={appointmentData.Description} onChange={handleAppointmentChange} className="action-textarea" style={{ minHeight: '80px' }} placeholder="Start typing the details about the appointment..."></textarea>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Remarks</label>
                                        <textarea name="Remarks" value={appointmentData.Remarks} onChange={handleRemarksChange} className="action-textarea" style={{ minHeight: '80px' }} placeholder="Add any additional remarks..."></textarea>
                                        <span style={{ fontSize: '12px', color: '#94a3b8', textAlign: 'left', marginTop: '4px' }}>{2000 - (appointmentData.Remarks?.length || 0)} characters left</span>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Start Date and Time <span style={{ color: '#ef4444' }}>*</span></label>
                                        <div className="premium-datetime-container" onClick={(e) => e.currentTarget.querySelector('input').showPicker()}>
                                            <Calendar size={18} className="datetime-icon" />
                                            <div className="premium-datetime-value">
                                                {formatDateTimeDisplay(appointmentData.StartDate, appointmentData.StartTime)}
                                            </div>
                                            <input
                                                type="datetime-local"
                                                value={`${appointmentData.StartDate}T${appointmentData.StartTime}`}
                                                onChange={(e) => handleCombinedDateTimeChange(e, setAppointmentData, 'StartDate', 'StartTime')}
                                                className="hidden-datetime-input"
                                            />
                                        </div>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">End Date and Time <span style={{ color: '#ef4444' }}>*</span></label>
                                        <div className="premium-datetime-container" onClick={(e) => e.currentTarget.querySelector('input').showPicker()}>
                                            <Calendar size={18} className="datetime-icon" />
                                            <div className="premium-datetime-value">
                                                {formatDateTimeDisplay(appointmentData.EndDate, appointmentData.EndTime)}
                                            </div>
                                            <input
                                                type="datetime-local"
                                                value={`${appointmentData.EndDate}T${appointmentData.EndTime}`}
                                                onChange={(e) => handleCombinedDateTimeChange(e, setAppointmentData, 'EndDate', 'EndTime')}
                                                className="hidden-datetime-input"
                                            />
                                        </div>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Where <span style={{ color: '#ef4444' }}>*</span></label>
                                        <input type="text" name="Where" value={appointmentData.Where} onChange={handleAppointmentChange} className="action-input" ref={whereInputRef} placeholder="Enter location of appointment..." />
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Complete Address</label>
                                        <textarea name="CompleteAddress" value={appointmentData.CompleteAddress} onChange={handleAppointmentChange} className="action-textarea" style={{ minHeight: '80px' }} placeholder="Please enter complete address."></textarea>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Owner <span style={{ color: '#ef4444' }}>*</span></label>
                                        <select name="Owner" value={appointmentData.Owner} onChange={handleAppointmentChange} className="action-select">
                                            {assignedToOptions.map((opt, i) => <option key={i} value={opt.Code || opt.Id}>{opt.Text || opt.Name}</option>)}
                                        </select>
                                    </div>
                                    <div className="action-form-row" ref={collabRef} style={{ position: 'relative' }}>
                                        <label className="action-form-label">Collaborators</label>
                                        <div
                                            className="action-textarea"
                                            style={{ cursor: 'pointer', minHeight: '46px', display: 'flex', flexWrap: 'wrap', alignItems: 'center', padding: '10px 12px', gap: '6px' }}
                                            onClick={() => setShowCollabDropdown(!showCollabDropdown)}
                                        >
                                            {appointmentData.Collaborators.length > 0
                                                ? collaboratorOptions.filter(c => appointmentData.Collaborators.includes((c.id || c.Code || c.Id || '').toString())).map(c => (
                                                    <span key={c.id || c.Code || c.Id} style={{ background: '#e2e8f0', color: '#475569', padding: '2px 8px', borderRadius: '4px', fontSize: '12px', display: 'flex', alignItems: 'center', gap: '6px', border: '1px solid #cbd5e1' }}>
                                                        {c.Text || c.Name}
                                                        <X size={12} style={{ cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); handleCollabToggle((c.id || c.Code || c.Id || '').toString()); }} />
                                                    </span>
                                                ))
                                                : <span style={{ color: '#94a3b8' }}>--Select Collaborator--</span>}
                                            <div style={{ flex: 1 }}></div>
                                            <ChevronRight size={14} style={{ transform: showCollabDropdown ? 'rotate(-90deg)' : 'rotate(90deg)', transition: 'transform 0.2s', color: '#94a3b8' }} />
                                        </div>
                                        {showCollabDropdown && (
                                            <div className="checkbox-list" style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 100, background: 'white', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', marginTop: '4px', maxHeight: '200px', overflowY: 'auto' }}>
                                                {collaboratorOptions.map((c, i) => {
                                                    const id = (c.id || c.Code || c.Id || '').toString();
                                                    return (
                                                        <label key={i} className="checkbox-item" style={{ padding: '8px 12px' }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={appointmentData.Collaborators.includes(id)}
                                                                onChange={() => handleCollabToggle(id)}
                                                            />
                                                            {c.Text || c.Name}
                                                        </label>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="action-footer">
                                    <button onClick={handleResetAppointment} style={{ background: 'none', border: 'none', color: '#64748b', fontWeight: '500', cursor: 'pointer' }}>Reset</button>
                                    <button className="btn-save" onClick={handleSaveAppointment} disabled={isSubmitting}>
                                        SAVE
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {(currentMode === 'adddeal' || currentMode === 'add-deal') && (
                        <div className="action-card">
                            <div className="action-card-header" style={{ padding: '16px 20px', borderBottom: '1px solid #f1f5f9' }}>
                                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '700', color: '#1e293b' }}>Add Deal</h3>
                            </div>
                            <div className="action-card-body">
                                <div className="action-form-grid">
                                    <div className="action-form-row">
                                        <label className="action-form-label">Deal value <span style={{ color: '#ef4444' }}>*</span></label>
                                        <input
                                            type="text"
                                            name="Amount"
                                            value={dealData.Amount}
                                            onChange={handleDealChange}
                                            className="action-input"
                                            placeholder="Please Enter Value"
                                            inputMode="numeric"
                                        />
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Deal pipeline</label>
                                        <select name="PipelineId" value={dealData.PipelineId} onChange={(e) => {
                                            const pid = e.target.value;
                                            setDealData(prev => ({ ...prev, PipelineId: pid }));
                                            fetchDealStages(pid);
                                        }} className="action-select">
                                            <option value="">--Select Pipeline--</option>
                                            {dealPipelines.map((p, i) => <option key={i} value={p.id}>{p.name}</option>)}
                                        </select>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Deal Stage <span style={{ color: '#ef4444' }}>*</span></label>
                                        <select name="PipelineStage" value={dealData.PipelineStage} onChange={handleDealChange} className="action-select">
                                            <option value="">--Select Stage--</option>
                                            {dealStages.map((s, i) => <option key={i} value={s.id}>{s.name}</option>)}
                                        </select>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Probability(%) <span style={{ color: '#ef4444' }}>*</span></label>
                                        <input
                                            type="text"
                                            name="Probability"
                                            value={dealData.Probability}
                                            onChange={handleDealChange}
                                            className="action-input"
                                            placeholder="Enter Probability"
                                            inputMode="numeric"
                                            max="100"
                                        />
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Sales owner</label>
                                        <select name="DealOwner" value={dealData.DealOwner} onChange={handleDealChange} className="action-select">
                                            {salesOwners.map((owner, i) => (
                                                <option key={i} value={owner.id}>{owner.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Estimated Closure Date <span style={{ color: '#ef4444' }}>*</span></label>
                                        <div className="premium-datetime-container" onClick={(e) => e.currentTarget.querySelector('input').showPicker()}>
                                            <Calendar size={18} className="datetime-icon" />
                                            <div className="premium-datetime-value">
                                                {dealData.ClosureDate ? `${dealData.ClosureDate.split('-')[2]}-${["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][parseInt(dealData.ClosureDate.split('-')[1]) - 1]}-${dealData.ClosureDate.split('-')[0]}` : ""}
                                            </div>
                                            <input
                                                type="date"
                                                name="ClosureDate"
                                                value={dealData.ClosureDate}
                                                min={new Date().toISOString().split('T')[0]}
                                                onChange={handleDealChange}
                                                className="hidden-datetime-input"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="action-footer">
                                    <button className="btn-reset" onClick={handleResetDeal} style={{ background: 'none', border: 'none', color: '#64748b', fontWeight: '500', cursor: 'pointer' }}>
                                        Reset
                                    </button>
                                    <button type="button" className="btn-save" onClick={handleSaveDeal} disabled={isSubmitting}>
                                        SAVE
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {(currentMode === 'voice' || currentMode === 'send-voice') && (
                        <div className="action-card">
                            <div className="action-card-body">
                                <div className="action-form-grid">
                                    <div className="action-form-row">
                                        <label className="section-label">Select Caller Number</label>
                                        <div className="checkbox-list">
                                            {(leadInfo || (entity?.mobiles && entity.mobiles.length > 0)) ? (() => {
                                                const numbers = leadInfo 
                                                    ? [leadInfo.MobileNo, leadInfo.Phones].filter(Boolean).filter((v, i, a) => a.indexOf(v) === i)
                                                    : (entity.mobiles || []);
                                                if (numbers.length === 0) return <p className="no-data-found-msg" style={{ color: '#ef4444', fontSize: '13px', padding: '10px' }}>No Mobile no found</p>;
                                                return numbers.map(num => (
                                                    <label key={num} className="checkbox-item">
                                                        <input type="radio" name="ChooseNumbers" value={num} checked={sendVoiceData.ChooseNumbers.includes(num)} onChange={handleSendVoiceChange} />
                                                        {num}
                                                    </label>
                                                ));
                                            })() : <p>Loading numbers...</p>}
                                        </div>
                                    </div>

                                    <div className="action-form-row">
                                        <label className="action-form-label">Caller ID (DNI) <span style={{ color: '#ef4444' }}>*</span></label>
                                        <select name="DnidNo" value={sendVoiceData.DnidNo} onChange={handleSendVoiceChange} className="action-select">
                                            {dniNumbers.map((d, i) => <option key={i} value={d.Code || d.Id}>{d.Code || d.Text || d.DniNo}</option>)}
                                        </select>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">App Flow <span style={{ color: '#ef4444' }}>*</span></label>
                                        <select name="AppFlow" value={sendVoiceData.AppFlow} onChange={handleSendVoiceChange} className="action-select">
                                            {appFlows.map((a, i) => <option key={i} value={a.Id || a.AppId}>{a.Text || a.AppFlowName}</option>)}
                                        </select>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Duration (Seconds)</label>
                                        <input type="number" name="Duration" value={sendVoiceData.Duration} onChange={handleSendVoiceChange} className="action-input" />
                                    </div>
                                </div>
                                <div className="action-footer">
                                    <button onClick={handleResetVoice} style={{ background: 'none', border: 'none', color: '#64748b', fontWeight: '500', cursor: 'pointer' }}>Reset</button>
                                    <button type="button" className="btn-save" onClick={handleSendVoice} disabled={isSubmitting}>
                                        SEND VOICE CALL
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {(currentMode === 'fillWebform' || currentMode === 'fill-webform') && (
                        <div className="action-card">
                            <div className="action-card-body">
                                <div className="action-form-grid">
                                    <div className="action-form-row">
                                        <label className="section-label">Select Webform to Fill <span style={{ color: '#ef4444' }}>*</span></label>
                                        <select
                                            value={selectedWebform}
                                            onChange={(e) => setSelectedWebform(e.target.value)}
                                            className="action-select"
                                            style={{ color: '#1e293b' }}
                                        >
                                            <option value="" style={{ color: '#64748b' }}>--Select Webform--</option>
                                            {webforms.map((w, i) => {
                                                const wfName = w.Text || w.WebFormName || w.Name || "";
                                                return (
                                                    <option key={i} value={wfName} style={{ color: '#1e293b' }}>
                                                        {wfName || "Unnamed Webform"}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                </div>
                                <div className="action-footer">
                                    <button 
                                        className="btn-reset" 
                                        onClick={handleResetWebform} 
                                        style={{ background: 'none', border: 'none', color: '#64748b', fontWeight: '500', cursor: 'pointer' }}
                                    >
                                        Reset
                                    </button>
                                    <button type="button" className="btn-save" onClick={() => {
                                        if (selectedWebform) {
                                            const leadId = entity?.enquiryId || entity?.leadId || entity?.id || "";
                                            const agentId = DEFAULT_USER_ID;

                                            // Using the exact URL format from the working example
                                            const wfUrl = `https://kit19.com/UserCRMCampaign/webFormDetails.aspx?ParentID=${agentId}&cName=${encodeURIComponent(selectedWebform)}&EntityName=Lead&AgentId=${agentId}&EntityId=${leadId}`;
                                            window.open(wfUrl, '_blank');
                                        }
                                    }} disabled={!selectedWebform}>
                                        OPEN WEBFORM <ExternalLink size={14} style={{ marginLeft: '8px' }} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {(currentMode === 'whatsapp' || currentMode === 'send-whatsapp') && (
                        <div className="action-card">
                            <div className="action-card-body">
                                {isCheckingRegistration ? (
                                    <div className="whatsapp-loading">Checking WhatsApp registration...</div>
                                ) : isRegisteredForWhatsapp === false ? (
                                    <div className="whatsapp-alert error">
                                        <Info size={20} />
                                        <span>This lead is not registered for WhatsApp messaging.</span>
                                    </div>
                                ) : (
                                    <div className="action-form-grid">
                                        {!selectedTemplate || whatsappStep === 'none' ? (
                                            <div className="template-selection-trigger">
                                                <button type="button" className="btn-template-select" onClick={() => setWhatsappStep('list')}>
                                                    SELECT TEMPLATE
                                                </button>
                                                <p className="helper-text">Please select an approved WhatsApp template to continue.</p>
                                            </div>
                                        ) : (
                                            <>
                                                <div className="selected-template-info">
                                                    <div className="flex justify-between items-center mb-2">
                                                        <label className="section-label">Template: {selectedTemplate.templatename || selectedTemplate.MailTemplateName || selectedTemplate.Name}</label>
                                                        <button type="button" className="text-blue-500 text-xs font-semibold" onClick={() => setWhatsappStep('list')}>Change</button>
                                                    </div>
                                                </div>

                                                <div className="template-preview-form">
                                                    <label className="action-form-label">Template Variables</label>
                                                    {Object.keys(whatsappVariables).length > 0 ? (
                                                        <div className="variable-inputs">
                                                            {Object.keys(whatsappVariables).map(key => (
                                                                <div key={key} className="action-form-row mb-3">
                                                                    <label className="text-xs text-slate-500 font-semibold mb-1">Variable {'{{'}{key}{'}}'}</label>
                                                                    <input
                                                                        type="text"
                                                                        className="action-input"
                                                                        placeholder={`Value for variable ${key}`}
                                                                        value={whatsappVariables[key]}
                                                                        onChange={(e) => handleWhatsappVariableChange(key, e.target.value)}
                                                                    />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <p className="text-xs text-slate-400 italic">This template has no dynamic variables.</p>
                                                    )}
                                                </div>

                                                <div className="message-preview-box">
                                                    <label className="action-form-label">Message Preview</label>
                                                    <div className="whatsapp-message-bubble">
                                                        {(selectedTemplate.Content || selectedTemplate.Message || selectedTemplate.MailTemplateContent || "")
                                                            .split(/(\{\{\d+\}\})/).map((part, i) => {
                                                                const match = part.match(/\{\{(\d+)\}\}/);
                                                                if (match) {
                                                                    return <span key={i} className="variable-placeholder">{whatsappVariables[match[1]] || match[0]}</span>;
                                                                }
                                                                return part;
                                                            })}
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                )}
                                {selectedTemplate && (
                                    <div className="action-footer">
                                        <button onClick={() => { setSelectedTemplate(null); setWhatsappStep('none'); }} style={{ background: 'none', border: 'none', color: '#64748b', fontWeight: '500', cursor: 'pointer' }}>Reset</button>
                                        <button type="button" className="btn-save whatsapp-btn" onClick={handleSendWhatsapp} disabled={isSubmitting}>
                                            SEND WHATSAPP
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* WhatsApp Template Modal */}
            {whatsappStep === 'list' && (
                <div className="whatsapp-modal-overlay">
                    <div className="whatsapp-modal-container">
                        <div className="whatsapp-modal-header">
                            <h3>Select Template</h3>
                            <button type="button" onClick={() => setWhatsappStep('none')}><X size={20} /></button>
                        </div>
                        <div className="whatsapp-modal-body">
                            <div className="modal-search-wrapper">
                                <Search size={18} className="search-icon" />
                                <input
                                    type="text"
                                    placeholder="Search Template"
                                    value={whatsappSearchTerm}
                                    onChange={(e) => setWhatsappSearchTerm(e.target.value)}
                                />
                            </div>
                            <div className="template-list">
                                {whatsappTemplates
                                    .filter(t => (t.templatename || t.MailTemplateName || t.Name || "").toLowerCase().includes(whatsappSearchTerm.toLowerCase()))
                                    .map((template, idx) => (
                                        <div
                                            key={idx}
                                            className={`template-item ${String(selectedTemplate?.id) === String(template.id) ? 'selected' : ''}`}
                                            onClick={() => handleWhatsappTemplateSelect(template)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <input
                                                type="radio"
                                                name="whatsapp-template"
                                                checked={String(selectedTemplate?.id) === String(template.id) || String(selectedTemplate?.MailTemplateId) === String(template.MailTemplateId)}
                                                onChange={() => handleWhatsappTemplateSelect(template)}
                                            />
                                            <span>{template.templatename || template.MailTemplateName || template.Name} (en)</span>
                                        </div>
                                    ))}
                            </div>
                        </div>
                        <div className="whatsapp-modal-footer">
                            <button type="button" className="btn-cancel" onClick={() => setWhatsappStep('none')}>Cancel</button>
                            <button type="button" className="btn-confirm" onClick={() => handleWhatsappTemplateSelect(selectedTemplate)}>Select Template</button>
                        </div>
                    </div>
                </div>
            )}

            {/* WhatsApp Template Preview Modal */}
            {whatsappStep === 'preview' && selectedTemplate && (
                <div className="whatsapp-modal-overlay">
                    <div className="whatsapp-modal-container preview-modal-wide">
                        <div className="whatsapp-modal-header">
                            <h3>Template Preview</h3>
                            <button type="button" onClick={() => setWhatsappStep('none')}><X size={20} /></button>
                        </div>
                        <div className="whatsapp-modal-body">
                            <div className="preview-grid">
                                <div className="preview-params-pane">
                                    <h4 className="pane-title">Example values</h4>
                                    <p className="pane-subtitle">Placeholders (Click to Add Placeholders)</p>

                                    <div className="params-list">
                                        {Object.keys(whatsappVariables).length > 0 ? (
                                            Object.keys(whatsappVariables).map(key => (
                                                <div key={key} className="param-item">
                                                    <label>Variable {'{{'}{key}{'}}'}</label>
                                                    <div className="param-input-group">
                                                        <div className="flex gap-2">
                                                            <select
                                                                className="action-select flex-1"
                                                                value={whatsappVariables[key].startsWith('[') ? whatsappVariables[key] : ''}
                                                                onChange={(e) => handleWhatsappVariableChange(key, e.target.value)}
                                                            >
                                                                <option value="">--Select Placeholder--</option>
                                                                {MERGE_FIELDS.map(f => (
                                                                    <option key={f.value} value={f.value}>{f.label}</option>
                                                                ))}
                                                            </select>
                                                            <button type="button" className="p-2 bg-slate-400 text-white rounded-md">
                                                                <CheckCircle size={18} />
                                                            </button>
                                                        </div>
                                                        <input
                                                            type="text"
                                                            className="action-input mt-2"
                                                            placeholder="Or type manual value..."
                                                            value={whatsappVariables[key].startsWith('[') ? '' : whatsappVariables[key]}
                                                            onChange={(e) => handleWhatsappVariableChange(key, e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <p className="no-params-text">This template has no dynamic variables.</p>
                                        )}
                                    </div>
                                </div>
                                <div className="preview-content-pane">
                                    <h4 className="pane-title">Preview</h4>
                                    <div className="whatsapp-message-bubble">
                                        {selectedTemplate.extractedHeader && (
                                            <div className="whatsapp-header mb-2 font-bold text-slate-800 border-b border-slate-100 pb-1">
                                                {selectedTemplate.extractedHeader.split(/(\{\{\d+\}\})/).map((part, i) => {
                                                    const match = part.match(/\{\{(\d+)\}\}/);
                                                    if (match) {
                                                        const varKey = match[1];
                                                        return <span key={i} className="variable-placeholder">{whatsappVariables[varKey] || part}</span>;
                                                    }
                                                    return part;
                                                })}
                                            </div>
                                        )}

                                        <div className="whatsapp-body">
                                            {(selectedTemplate.extractedContent || selectedTemplate.Content || selectedTemplate.Message || "")
                                                .split(/(\{\{\d+\}\})/).map((part, i) => {
                                                    const match = part.match(/\{\{(\d+)\}\}/);
                                                    if (match) {
                                                        const varKey = match[1];
                                                        return <span key={i} className="variable-placeholder">{whatsappVariables[varKey] || part}</span>;
                                                    }
                                                    return part;
                                                })
                                            }
                                        </div>

                                        {selectedTemplate.extractedFooter && (
                                            <div className="whatsapp-footer mt-2 text-slate-400 text-xs italic">
                                                {selectedTemplate.extractedFooter}
                                            </div>
                                        )}
                                    </div>

                                    {(selectedTemplate.extractedButtons || selectedTemplate.Buttons) && (selectedTemplate.extractedButtons || selectedTemplate.Buttons).length > 0 && (
                                        <div className="preview-buttons mt-4">
                                            {(selectedTemplate.extractedButtons || selectedTemplate.Buttons).map((btn, i) => (
                                                <div key={i} className="whatsapp-preview-button">
                                                    {btn.text || btn.Text || "Button"}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="whatsapp-modal-footer">
                            <button type="button" className="btn-cancel" onClick={handleBackToSelection}>Back</button>
                            <button type="button" className="btn-confirm whatsapp-btn" onClick={handleSendWhatsapp} disabled={isSubmitting}>
                                Send
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <Alert
                {...alertConfig}
                onCancel={() => setAlertConfig(prev => ({ ...prev, show: false }))}
            />

            {/* Email Template Preview Modal */}
            {showTemplatePreview && (
                <div className="template-preview-overlay" onClick={handleCloseTemplate}>
                    <div className="template-preview-container" onClick={(e) => e.stopPropagation()}>
                        <div className="template-preview-header">
                            <h3>{previewTemplate.name || 'Template Preview'}</h3>
                            <div className="preview-header-actions">
                                {previewTemplate.url && (
                                    <a
                                        href={previewTemplate.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn-new-tab"
                                    >
                                        <ExternalLink size={16} /> View in New Tab
                                    </a>
                                )}
                                <button className="btn-close-preview" onClick={handleCloseTemplate}>
                                    <X size={20} />
                                </button>
                            </div>
                        </div>
                        <div className="template-preview-body">
                            <iframe
                                title="Template Preview"
                                className="preview-iframe"
                                srcDoc={previewTemplate.html}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LeadActionOperation;
